/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type Account = {
  __typename: "Account";
  id: string;
  gid: string;
  name: string;
  projects?: ModelProjectConnection | null;
  fileuploads?: Array<FileUpload> | null;
  integrations?: Integrations | null;
  aliasId: string;
  fonts?: Array<AccountFont> | null;
  minisiteDomain?: string | null;
  mfaEnabled?: boolean | null;
  ownerId?: string | null;
  users?: ModelAccountUserConnection | null;
  accountUsageType?: string | null;
  companySize?: string | null;
  tierId: string;
  tier?: Tier | null;
  stripeCustomerId?: string | null;
  featureOverrides?: ModelAccountFeatureOverrideConnection | null;
  createNewVideosWithBlingLogo?: boolean | null;
  accountType?: AccountType | null;
  currentBillingPeriod?: BillingPeriod | null;
  ppvCurrentBillingPeriod?: BillingPeriod | null;
  availableSceneLibraries?: ModelAccountSceneLibrariesConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelProjectConnection = {
  __typename: "ModelProjectConnection";
  items: Array<Project | null>;
  nextToken?: string | null;
};

export type Project = {
  __typename: "Project";
  id: string;
  projectAccountId: string;
  title: string;
  account: Account;
  videoParts?: Array<VidPart> | null;
  allowCreateDataPoint?: boolean | null;
  allowDataConnect?: boolean | null;
  allowCrmConnect?: boolean | null;
  allowSdkConnect?: boolean | null;
  allowSendFormData?: boolean | null;
  analyticsReportUrl?: string | null;
  createdAt?: string | null;
  dataFiles?: Array<DataFile | null> | null;
  description?: string | null;
  fileName?: string | null;
  jsonChanges?: string | null;
  jsonVidUrl?: string | null;
  playerSettings?: PlayerSettings | null;
  projectVersions?: ModelProjectVersionConnection | null;
  formData?: ModelFormDataConnection | null;
  settings?: string | null;
  stateJsonSchemaStr?: string | null;
  settingsJsonSchemaStr?: string | null;
  thumbS3Url?: string | null;
  experiments?: Array<Experiment> | null;
  experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
  analyticsEnabled?: boolean | null;
  owner?: string | null;
  renders?: ModelServerRenderConnection | null;
  notifications?: ModelNotificationConnection | null;
  aliasId: string;
  minisiteConfigs?: Array<MinisiteConfig> | null;
  playerVersionToUse?: string | null;
  customHtml?: string | null;
  dynamicThumbnails?: Array<DynamicThumbnail | null> | null;
  publishedAt?: string | null;
  allowedOrigins?: Array<string | null> | null;
  flowDiagram?: FlowDiagram | null;
  nodeLayout?: NodeLayoutMap | null;
  textToVideoScript?: string | null;
  instantiatedFromUseCase?: string | null;
  overlay?: Overlay | null;
  fontOverrides?: Array<Font> | null;
  isDeleted?: boolean | null;
  availableSceneLibraries?: ModelProjectSceneLibrariesConnection | null;
  fontMap?: Array<FontMap> | null;
  updatedAt: string;
};

export type VidPart = {
  __typename: "VidPart";
  name: string;
  jsonUrl: string;
  modsArr?: Array<Mod> | null;
  mods?: string | null;
  fonts?: Array<Font> | null;
  updatedAt?: string | null;
  hasVideo?: boolean | null;
  origin?: string | null;
  playerVersionToUse?: string | null;
  description?: string | null;
};

export type Mod = {
  __typename: "Mod";
  id: number;
  name?: string | null;
  dataStr: string;
  origin?: string | null;
  description?: string | null;
};

export type Font = {
  __typename: "Font";
  family: string;
  url: string;
  weight: string;
  style: string;
};

export type DataFile = {
  __typename: "DataFile";
  fileName?: string | null;
  tag?: string | null;
  createdAt?: string | null;
};

export type PlayerSettings = {
  __typename: "PlayerSettings";
  autoplay?: boolean | null;
  autoplay_delay?: number | null;
  posterFrame?: number | null;
  showTimeline?: boolean | null;
  storiesMode?: boolean | null;
  color_loader?: string | null;
  color_ctrlBtns?: string | null;
  color_rail?: string | null;
  color_progress?: string | null;
  color_thumb?: string | null;
  color_bg?: string | null;
  muted?: boolean | null;
  autoReplay?: boolean | null;
  showBlingsLogo?: number | null;
  blingsLogoColor?: string | null;
  loadingText?: string | null;
  loadingImage?: string | null;
};

export type ModelProjectVersionConnection = {
  __typename: "ModelProjectVersionConnection";
  items: Array<ProjectVersion | null>;
  nextToken?: string | null;
};

export type ProjectVersion = {
  __typename: "ProjectVersion";
  id: string;
  accountOwner: string;
  owner?: string | null;
  stateJsonSchemaStr?: string | null;
  settingsJsonSchemaStr?: string | null;
  settings?: string | null;
  videoParts?: Array<VidPart> | null;
  updatedAt?: string | null;
  playerVersionToUse?: string | null;
  experiments?: Array<Experiment> | null;
  experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
  textToVideoScript?: string | null;
  flowDiagram?: FlowDiagram | null;
  nodeLayout?: NodeLayoutMap | null;
  overlay?: Overlay | null;
  fontOverrides?: Array<Font> | null;
  playerSettings?: PlayerSettings | null;
  fontMap?: Array<FontMap> | null;
  createdAt: string;
  projectProjectVersionsId?: string | null;
};

export type Experiment = {
  __typename: "Experiment";
  id: string;
  variants?: Array<Variant> | null;
  type: string;
};

export type Variant = {
  __typename: "Variant";
  id: string;
  value: string;
  successFactors: SuccessFactors;
};

export type SuccessFactors = {
  __typename: "SuccessFactors";
  conversionSuccessData: number;
  engagementSuccessData: number;
  selectionCount: number;
  watchTimeSuccessData: number;
};

export enum ExperimentOptimizationTechnique {
  CONVERSION = "CONVERSION",
  ENGAGEMENT = "ENGAGEMENT",
  WATCH_TIME = "WATCH_TIME",
  BLINGS_MAGIC = "BLINGS_MAGIC",
  DISABLED = "DISABLED",
}

export type FlowDiagram = {
  __typename: "FlowDiagram";
  nodes: Array<FlowNode>;
  edges: Array<FlowEdge>;
};

export type FlowNode = {
  __typename: "FlowNode";
  id: string;
  label: string;
  type: FlowNodeType;
  data?: string | null;
  lineupId?: string | null;
};

export enum FlowNodeType {
  scene = "scene",
  condition = "condition",
  lineup = "lineup",
  condition_multi = "condition_multi",
  ab_test = "ab_test",
}

export type FlowEdge = {
  __typename: "FlowEdge";
  source: string;
  target: string;
  sourceHandle?: string | null;
  index?: number | null;
};

export type NodeLayoutMap = {
  __typename: "NodeLayoutMap";
  entries: Array<NodeLayoutEntry>;
};

export type NodeLayoutEntry = {
  __typename: "NodeLayoutEntry";
  nodeId: string;
  position: NodeLayoutPosition;
};

export type NodeLayoutPosition = {
  __typename: "NodeLayoutPosition";
  x: number;
  y: number;
};

export type Overlay = {
  __typename: "Overlay";
  audio?: Array<OverlayAudio> | null;
};

export type OverlayAudio = {
  __typename: "OverlayAudio";
  url: string;
  volume?: number | null;
  loop?: boolean | null;
};

export type FontMap = {
  __typename: "FontMap";
  slot: string;
  font: Font;
};

export type ModelFormDataConnection = {
  __typename: "ModelFormDataConnection";
  items: Array<FormData | null>;
  nextToken?: string | null;
};

export type FormData = {
  __typename: "FormData";
  id: string;
  accountOwner: string;
  projectFormDataId: string;
  project: Project;
  data: string;
  sessionId: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
};

export type ModelServerRenderConnection = {
  __typename: "ModelServerRenderConnection";
  items: Array<ServerRender | null>;
  nextToken?: string | null;
};

export type ServerRender = {
  __typename: "ServerRender";
  id: string;
  projectId: string;
  project: Project;
  scenes: Array<string>;
  data?: string | null;
  env?: string | null;
  outputFileName?: string | null;
  quality?: number | null;
  frameToStart?: number | null;
  frameToEnd?: number | null;
  format?: string | null;
  status?: ProjectStatus | null;
  cognitoUserIdentifier?: string | null;
  cognitoGroupOwner?: string | null;
  createdAt?: string | null;
  updatedAt: string;
};

export type ProjectStatus = {
  __typename: "ProjectStatus";
  ready?: string | null;
  status?: string | null;
  downloadLink?: string | null;
  code?: string | null;
};

export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection";
  items: Array<Notification | null>;
  nextToken?: string | null;
};

export type Notification = {
  __typename: "Notification";
  id: string;
  type: string;
  subType?: string | null;
  status: NotificationStatus;
  title: string;
  message: string;
  read: boolean;
  owner: string;
  projectId?: string | null;
  project?: Project | null;
  createdAt: string;
  extra?: string | null;
  updatedAt: string;
  projectNotificationsId?: string | null;
};

export enum NotificationStatus {
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  ERROR = "ERROR",
}

export type MinisiteConfig = {
  __typename: "MinisiteConfig";
  scenes?: Array<string> | null;
  title?: string | null;
  description?: string | null;
  thumbUrl?: string | null;
  faviconUrl?: string | null;
  preCreate?: string | null;
};

export type DynamicThumbnail = {
  __typename: "DynamicThumbnail";
  name?: string | null;
  id: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ModelProjectSceneLibrariesConnection = {
  __typename: "ModelProjectSceneLibrariesConnection";
  items: Array<ProjectSceneLibraries | null>;
  nextToken?: string | null;
};

export type ProjectSceneLibraries = {
  __typename: "ProjectSceneLibraries";
  id: string;
  projectID: string;
  sceneLibraryID: string;
  project: Project;
  sceneLibrary: SceneLibrary;
  createdAt: string;
  updatedAt: string;
};

export type SceneLibrary = {
  __typename: "SceneLibrary";
  id: string;
  title: string;
  vibe?: string | null;
  projectId: string;
  project?: Project | null;
  description?: string | null;
  thumbnail?: string | null;
  accounts?: ModelAccountSceneLibrariesConnection | null;
  useCases?: ModelUseCaseSceneLibrariesConnection | null;
  projects?: ModelProjectSceneLibrariesConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelAccountSceneLibrariesConnection = {
  __typename: "ModelAccountSceneLibrariesConnection";
  items: Array<AccountSceneLibraries | null>;
  nextToken?: string | null;
};

export type AccountSceneLibraries = {
  __typename: "AccountSceneLibraries";
  id: string;
  accountID: string;
  sceneLibraryID: string;
  account: Account;
  sceneLibrary: SceneLibrary;
  createdAt: string;
  updatedAt: string;
};

export type ModelUseCaseSceneLibrariesConnection = {
  __typename: "ModelUseCaseSceneLibrariesConnection";
  items: Array<UseCaseSceneLibraries | null>;
  nextToken?: string | null;
};

export type UseCaseSceneLibraries = {
  __typename: "UseCaseSceneLibraries";
  id: string;
  sceneLibraryID: string;
  useCaseID: string;
  sceneLibrary: SceneLibrary;
  useCase: UseCase;
  createdAt: string;
  updatedAt: string;
};

export type UseCase = {
  __typename: "UseCase";
  id: string;
  name: string;
  projectId: string;
  images?: Array<string> | null;
  shortDescription?: string | null;
  longDescription?: string | null;
  thumbnail?: string | null;
  demoLink?: string | null;
  videoPreview?: string | null;
  lineupId?: string | null;
  lineupsIds?: Array<string> | null;
  scenes?: Array<string> | null;
  liveControl?: string | null;
  liveControlSchema?: string | null;
  dynamicDataSchema?: string | null;
  categoryId?: string | null;
  category?: UseCaseCategory | null;
  availableSceneLibraries?: ModelUseCaseSceneLibrariesConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type UseCaseCategory = {
  __typename: "UseCaseCategory";
  id: string;
  name: string;
  description: string;
  thumbnail: string;
  useCases?: ModelUseCaseConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelUseCaseConnection = {
  __typename: "ModelUseCaseConnection";
  items: Array<UseCase | null>;
  nextToken?: string | null;
};

export type FileUpload = {
  __typename: "FileUpload";
  originalName?: string | null;
  createdAt: string;
  fileName: string;
  fileStatus?: string | null;
  fileError?: string | null;
  numRecords?: number | null;
  numErrors?: number | null;
  totalRecords?: number | null;
  writtenRecords?: number | null;
};

export type Integrations = {
  __typename: "Integrations";
  hubspot?: string | null;
};

export type AccountFont = {
  __typename: "AccountFont";
  fontFamily: string;
  variants: Array<FontVariant>;
};

export type FontVariant = {
  __typename: "FontVariant";
  name: string;
  weight: number;
  style: string;
  url?: string | null;
};

export type ModelAccountUserConnection = {
  __typename: "ModelAccountUserConnection";
  items: Array<AccountUser | null>;
  nextToken?: string | null;
};

export type AccountUser = {
  __typename: "AccountUser";
  id: string;
  email: string;
  account?: Account | null;
  accountId: string;
  user?: User | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
  workType?: string | null;
  roleInCompany?: string | null;
  permissions?: Array<string | null> | null;
};

export type User = {
  __typename: "User";
  id: string;
  email?: string | null;
  name?: string | null;
  lastName?: string | null;
  picture?: string | null;
  accounts?: ModelAccountUserConnection | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type Tier = {
  __typename: "Tier";
  id: string;
  name: string;
  monthlyPrice: string;
  annualPrice: string;
  description: string;
  enabled: boolean;
  features?: ModelTierFeatureConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelTierFeatureConnection = {
  __typename: "ModelTierFeatureConnection";
  items: Array<TierFeature | null>;
  nextToken?: string | null;
};

export type TierFeature = {
  __typename: "TierFeature";
  id: string;
  tier: Tier;
  tierId: string;
  feature: Feature;
  featureId: string;
  description?: string | null;
  limitValue?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type Feature = {
  __typename: "Feature";
  id: string;
  name: string;
  description?: string | null;
  enabled: boolean;
  tierFeatures?: ModelTierFeatureConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelAccountFeatureOverrideConnection = {
  __typename: "ModelAccountFeatureOverrideConnection";
  items: Array<AccountFeatureOverride | null>;
  nextToken?: string | null;
};

export type AccountFeatureOverride = {
  __typename: "AccountFeatureOverride";
  id: string;
  accountId: string;
  featureId: string;
  reason?: string | null;
  limitValue?: number | null;
  enabled: boolean;
  expiresAt?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type AccountType = {
  __typename: "AccountType";
  levelName: AccountTypeName;
  permissions?: AccountPermissions | null;
};

export enum AccountTypeName {
  FREEMIUM = "FREEMIUM",
  PRO = "PRO",
  ENTERPRISE = "ENTERPRISE",
}

export type AccountPermissions = {
  __typename: "AccountPermissions";
  removeBlingLogo?: boolean | null;
  aiOptimization?: boolean | null;
};

export type BillingPeriod = {
  __typename: "BillingPeriod";
  startDate: string;
  endDate: string;
};

export type CreateAccountInput = {
  id?: string | null;
  gid: string;
  name: string;
  fileuploads?: Array<FileUploadInput> | null;
  integrations?: IntegrationsInput | null;
  aliasId: string;
  fonts?: Array<AccountFontInput> | null;
  minisiteDomain?: string | null;
  mfaEnabled?: boolean | null;
  ownerId?: string | null;
  accountUsageType?: string | null;
  companySize?: string | null;
  tierId: string;
  stripeCustomerId?: string | null;
  createNewVideosWithBlingLogo?: boolean | null;
  accountType?: AccountTypeInput | null;
  currentBillingPeriod?: BillingPeriodInput | null;
  ppvCurrentBillingPeriod?: BillingPeriodInput | null;
};

export type FileUploadInput = {
  originalName?: string | null;
  createdAt: string;
  fileName: string;
  fileStatus?: string | null;
  fileError?: string | null;
  numRecords?: number | null;
  numErrors?: number | null;
  totalRecords?: number | null;
  writtenRecords?: number | null;
};

export type IntegrationsInput = {
  hubspot?: string | null;
};

export type AccountFontInput = {
  fontFamily: string;
  variants: Array<FontVariantInput>;
};

export type FontVariantInput = {
  name: string;
  weight: number;
  style: string;
  url?: string | null;
};

export type AccountTypeInput = {
  levelName: AccountTypeName;
  permissions?: AccountPermissionsInput | null;
};

export type AccountPermissionsInput = {
  removeBlingLogo?: boolean | null;
  aiOptimization?: boolean | null;
};

export type BillingPeriodInput = {
  startDate: string;
  endDate: string;
};

export type ModelAccountConditionInput = {
  gid?: ModelStringInput | null;
  name?: ModelStringInput | null;
  aliasId?: ModelStringInput | null;
  minisiteDomain?: ModelStringInput | null;
  mfaEnabled?: ModelBooleanInput | null;
  ownerId?: ModelIDInput | null;
  accountUsageType?: ModelStringInput | null;
  companySize?: ModelStringInput | null;
  tierId?: ModelIDInput | null;
  stripeCustomerId?: ModelStringInput | null;
  createNewVideosWithBlingLogo?: ModelBooleanInput | null;
  and?: Array<ModelAccountConditionInput | null> | null;
  or?: Array<ModelAccountConditionInput | null> | null;
  not?: ModelAccountConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type UpdateAccountInput = {
  id: string;
  gid?: string | null;
  name?: string | null;
  fileuploads?: Array<FileUploadInput> | null;
  integrations?: IntegrationsInput | null;
  aliasId?: string | null;
  fonts?: Array<AccountFontInput> | null;
  minisiteDomain?: string | null;
  mfaEnabled?: boolean | null;
  ownerId?: string | null;
  accountUsageType?: string | null;
  companySize?: string | null;
  tierId?: string | null;
  stripeCustomerId?: string | null;
  createNewVideosWithBlingLogo?: boolean | null;
  accountType?: AccountTypeInput | null;
  currentBillingPeriod?: BillingPeriodInput | null;
  ppvCurrentBillingPeriod?: BillingPeriodInput | null;
};

export type DeleteAccountInput = {
  id: string;
};

export type CreateInviteInput = {
  id?: string | null;
  senderId: string;
  email: string;
  accountId: string;
  confirmCode: string;
  confirmed: boolean;
  createdAt?: string | null;
  updatedAt?: string | null;
  permissions?: Array<string | null> | null;
};

export type ModelInviteConditionInput = {
  senderId?: ModelIDInput | null;
  email?: ModelStringInput | null;
  accountId?: ModelIDInput | null;
  confirmCode?: ModelStringInput | null;
  confirmed?: ModelBooleanInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  permissions?: ModelStringInput | null;
  and?: Array<ModelInviteConditionInput | null> | null;
  or?: Array<ModelInviteConditionInput | null> | null;
  not?: ModelInviteConditionInput | null;
};

export type Invite = {
  __typename: "Invite";
  id: string;
  senderId: string;
  email: string;
  accountId: string;
  account?: Account | null;
  confirmCode: string;
  confirmed: boolean;
  createdAt: string;
  updatedAt: string;
  permissions?: Array<string | null> | null;
};

export type UpdateInviteInput = {
  id: string;
  senderId?: string | null;
  email?: string | null;
  accountId?: string | null;
  confirmCode?: string | null;
  confirmed?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  permissions?: Array<string | null> | null;
};

export type DeleteInviteInput = {
  id: string;
};

export type CreateTierInput = {
  id?: string | null;
  name: string;
  monthlyPrice: string;
  annualPrice: string;
  description: string;
  enabled: boolean;
};

export type ModelTierConditionInput = {
  name?: ModelStringInput | null;
  monthlyPrice?: ModelStringInput | null;
  annualPrice?: ModelStringInput | null;
  description?: ModelStringInput | null;
  enabled?: ModelBooleanInput | null;
  and?: Array<ModelTierConditionInput | null> | null;
  or?: Array<ModelTierConditionInput | null> | null;
  not?: ModelTierConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateTierInput = {
  id: string;
  name?: string | null;
  monthlyPrice?: string | null;
  annualPrice?: string | null;
  description?: string | null;
  enabled?: boolean | null;
};

export type DeleteTierInput = {
  id: string;
};

export type CreateFeatureInput = {
  id?: string | null;
  name: string;
  description?: string | null;
  enabled: boolean;
};

export type ModelFeatureConditionInput = {
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  enabled?: ModelBooleanInput | null;
  and?: Array<ModelFeatureConditionInput | null> | null;
  or?: Array<ModelFeatureConditionInput | null> | null;
  not?: ModelFeatureConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateFeatureInput = {
  id: string;
  name?: string | null;
  description?: string | null;
  enabled?: boolean | null;
};

export type DeleteFeatureInput = {
  id: string;
};

export type CreateTierFeatureInput = {
  id?: string | null;
  tierId: string;
  featureId: string;
  description?: string | null;
  limitValue?: number | null;
};

export type ModelTierFeatureConditionInput = {
  tierId?: ModelIDInput | null;
  featureId?: ModelIDInput | null;
  description?: ModelStringInput | null;
  limitValue?: ModelIntInput | null;
  and?: Array<ModelTierFeatureConditionInput | null> | null;
  or?: Array<ModelTierFeatureConditionInput | null> | null;
  not?: ModelTierFeatureConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type UpdateTierFeatureInput = {
  id: string;
  tierId?: string | null;
  featureId?: string | null;
  description?: string | null;
  limitValue?: number | null;
};

export type DeleteTierFeatureInput = {
  id: string;
};

export type CreateAccountFeatureOverrideInput = {
  id?: string | null;
  accountId: string;
  featureId: string;
  reason?: string | null;
  limitValue?: number | null;
  enabled: boolean;
  expiresAt?: string | null;
};

export type ModelAccountFeatureOverrideConditionInput = {
  accountId?: ModelIDInput | null;
  featureId?: ModelIDInput | null;
  reason?: ModelStringInput | null;
  limitValue?: ModelIntInput | null;
  enabled?: ModelBooleanInput | null;
  expiresAt?: ModelStringInput | null;
  and?: Array<ModelAccountFeatureOverrideConditionInput | null> | null;
  or?: Array<ModelAccountFeatureOverrideConditionInput | null> | null;
  not?: ModelAccountFeatureOverrideConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateAccountFeatureOverrideInput = {
  id: string;
  accountId?: string | null;
  featureId?: string | null;
  reason?: string | null;
  limitValue?: number | null;
  enabled?: boolean | null;
  expiresAt?: string | null;
};

export type DeleteAccountFeatureOverrideInput = {
  id: string;
};

export type CreateFormDataInput = {
  id?: string | null;
  accountOwner: string;
  projectFormDataId: string;
  data: string;
  sessionId: string;
  userId: string;
  createdAt?: string | null;
};

export type ModelFormDataConditionInput = {
  accountOwner?: ModelStringInput | null;
  projectFormDataId?: ModelIDInput | null;
  data?: ModelStringInput | null;
  sessionId?: ModelStringInput | null;
  userId?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  and?: Array<ModelFormDataConditionInput | null> | null;
  or?: Array<ModelFormDataConditionInput | null> | null;
  not?: ModelFormDataConditionInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateFormDataInput = {
  id: string;
  accountOwner?: string | null;
  projectFormDataId?: string | null;
  data?: string | null;
  sessionId?: string | null;
  userId?: string | null;
  createdAt?: string | null;
};

export type DeleteFormDataInput = {
  id: string;
};

export type CreateNotificationInput = {
  id?: string | null;
  type: string;
  subType?: string | null;
  status: NotificationStatus;
  title: string;
  message: string;
  read: boolean;
  owner: string;
  projectId?: string | null;
  createdAt?: string | null;
  extra?: string | null;
  projectNotificationsId?: string | null;
};

export type ModelNotificationConditionInput = {
  type?: ModelStringInput | null;
  subType?: ModelStringInput | null;
  status?: ModelNotificationStatusInput | null;
  title?: ModelStringInput | null;
  message?: ModelStringInput | null;
  read?: ModelBooleanInput | null;
  owner?: ModelStringInput | null;
  projectId?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  extra?: ModelStringInput | null;
  and?: Array<ModelNotificationConditionInput | null> | null;
  or?: Array<ModelNotificationConditionInput | null> | null;
  not?: ModelNotificationConditionInput | null;
  updatedAt?: ModelStringInput | null;
  projectNotificationsId?: ModelIDInput | null;
};

export type ModelNotificationStatusInput = {
  eq?: NotificationStatus | null;
  ne?: NotificationStatus | null;
};

export type UpdateNotificationInput = {
  id: string;
  type?: string | null;
  subType?: string | null;
  status?: NotificationStatus | null;
  title?: string | null;
  message?: string | null;
  read?: boolean | null;
  owner?: string | null;
  projectId?: string | null;
  createdAt?: string | null;
  extra?: string | null;
  projectNotificationsId?: string | null;
};

export type DeleteNotificationInput = {
  id: string;
};

export type DeleteProjectInput = {
  id: string;
};

export type ModelProjectConditionInput = {
  projectAccountId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  allowCreateDataPoint?: ModelBooleanInput | null;
  allowDataConnect?: ModelBooleanInput | null;
  allowCrmConnect?: ModelBooleanInput | null;
  allowSdkConnect?: ModelBooleanInput | null;
  allowSendFormData?: ModelBooleanInput | null;
  analyticsReportUrl?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  description?: ModelStringInput | null;
  fileName?: ModelStringInput | null;
  jsonChanges?: ModelStringInput | null;
  jsonVidUrl?: ModelStringInput | null;
  settings?: ModelStringInput | null;
  stateJsonSchemaStr?: ModelStringInput | null;
  settingsJsonSchemaStr?: ModelStringInput | null;
  thumbS3Url?: ModelStringInput | null;
  experimentOptimizationTechnique?: ModelExperimentOptimizationTechniqueInput | null;
  analyticsEnabled?: ModelBooleanInput | null;
  owner?: ModelStringInput | null;
  aliasId?: ModelStringInput | null;
  playerVersionToUse?: ModelStringInput | null;
  customHtml?: ModelStringInput | null;
  publishedAt?: ModelStringInput | null;
  allowedOrigins?: ModelStringInput | null;
  textToVideoScript?: ModelStringInput | null;
  instantiatedFromUseCase?: ModelIDInput | null;
  isDeleted?: ModelBooleanInput | null;
  and?: Array<ModelProjectConditionInput | null> | null;
  or?: Array<ModelProjectConditionInput | null> | null;
  not?: ModelProjectConditionInput | null;
  updatedAt?: ModelStringInput | null;
};

export type ModelExperimentOptimizationTechniqueInput = {
  eq?: ExperimentOptimizationTechnique | null;
  ne?: ExperimentOptimizationTechnique | null;
};

export type CreateProjectVersionInput = {
  id?: string | null;
  accountOwner: string;
  owner?: string | null;
  stateJsonSchemaStr?: string | null;
  settingsJsonSchemaStr?: string | null;
  settings?: string | null;
  videoParts?: Array<VidPartInput> | null;
  updatedAt?: string | null;
  playerVersionToUse?: string | null;
  experiments?: Array<ExperimentInput> | null;
  experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
  textToVideoScript?: string | null;
  flowDiagram?: FlowDiagramInput | null;
  nodeLayout?: NodeLayoutMapInput | null;
  overlay?: OverlayInput | null;
  fontOverrides?: Array<FontInput> | null;
  playerSettings?: PlayerSettingsInput | null;
  fontMap?: Array<FontMapInput> | null;
  projectProjectVersionsId?: string | null;
};

export type VidPartInput = {
  name: string;
  jsonUrl: string;
  modsArr?: Array<ModInput> | null;
  mods?: string | null;
  fonts?: Array<FontInput> | null;
  hasVideo?: boolean | null;
  updatedAt?: string | null;
  origin?: string | null;
  playerVersionToUse?: string | null;
  description?: string | null;
};

export type ModInput = {
  id: number;
  name?: string | null;
  dataStr: string;
  origin?: string | null;
  description?: string | null;
};

export type FontInput = {
  family: string;
  url: string;
  weight: string;
  style: string;
};

export type ExperimentInput = {
  id: string;
  variants?: Array<VariantInput> | null;
  type: string;
};

export type VariantInput = {
  id: string;
  value: string;
  successFactors: SuccessFactorsInput;
};

export type SuccessFactorsInput = {
  conversionSuccessData: number;
  engagementSuccessData: number;
  selectionCount: number;
  watchTimeSuccessData: number;
};

export type FlowDiagramInput = {
  nodes: Array<FlowNodeInput>;
  edges: Array<FlowEdgeInput>;
};

export type FlowNodeInput = {
  id: string;
  label: string;
  type: FlowNodeType;
  data?: string | null;
  lineupId?: string | null;
};

export type FlowEdgeInput = {
  source: string;
  target: string;
  sourceHandle?: string | null;
  index?: number | null;
};

export type NodeLayoutMapInput = {
  entries: Array<NodeLayoutEntryInput>;
};

export type NodeLayoutEntryInput = {
  nodeId: string;
  position: NodeLayoutPositionInput;
};

export type NodeLayoutPositionInput = {
  x: number;
  y: number;
};

export type OverlayInput = {
  audio?: Array<OverlayAudioInput> | null;
};

export type OverlayAudioInput = {
  url: string;
  volume?: number | null;
  loop?: boolean | null;
};

export type PlayerSettingsInput = {
  posterFrame?: number | null;
  showTimeline?: boolean | null;
  storiesMode?: boolean | null;
  color_loader?: string | null;
  color_ctrlBtns?: string | null;
  color_rail?: string | null;
  color_progress?: string | null;
  color_thumb?: string | null;
  color_bg?: string | null;
  muted?: boolean | null;
  autoplay?: boolean | null;
  autoplay_delay?: number | null;
  autoReplay?: boolean | null;
  showBlingsLogo?: number | null;
  blingsLogoColor?: string | null;
  loadingText?: string | null;
  loadingImage?: string | null;
};

export type FontMapInput = {
  slot: string;
  font: FontInput;
};

export type ModelProjectVersionConditionInput = {
  accountOwner?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  stateJsonSchemaStr?: ModelStringInput | null;
  settingsJsonSchemaStr?: ModelStringInput | null;
  settings?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  playerVersionToUse?: ModelStringInput | null;
  experimentOptimizationTechnique?: ModelExperimentOptimizationTechniqueInput | null;
  textToVideoScript?: ModelStringInput | null;
  and?: Array<ModelProjectVersionConditionInput | null> | null;
  or?: Array<ModelProjectVersionConditionInput | null> | null;
  not?: ModelProjectVersionConditionInput | null;
  createdAt?: ModelStringInput | null;
  projectProjectVersionsId?: ModelIDInput | null;
};

export type DeleteProjectVersionInput = {
  id: string;
};

export type CreateSceneLibraryInput = {
  id?: string | null;
  title: string;
  vibe?: string | null;
  projectId: string;
  description?: string | null;
  thumbnail?: string | null;
};

export type ModelSceneLibraryConditionInput = {
  title?: ModelStringInput | null;
  vibe?: ModelStringInput | null;
  projectId?: ModelIDInput | null;
  description?: ModelStringInput | null;
  thumbnail?: ModelStringInput | null;
  and?: Array<ModelSceneLibraryConditionInput | null> | null;
  or?: Array<ModelSceneLibraryConditionInput | null> | null;
  not?: ModelSceneLibraryConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateSceneLibraryInput = {
  id: string;
  title?: string | null;
  vibe?: string | null;
  projectId?: string | null;
  description?: string | null;
  thumbnail?: string | null;
};

export type DeleteSceneLibraryInput = {
  id: string;
};

export type CreateServerRenderInput = {
  id?: string | null;
  projectId: string;
  scenes: Array<string>;
  data?: string | null;
  env?: string | null;
  outputFileName?: string | null;
  quality?: number | null;
  frameToStart?: number | null;
  frameToEnd?: number | null;
  format?: string | null;
  status?: ProjectStatusInput | null;
  cognitoUserIdentifier?: string | null;
  cognitoGroupOwner?: string | null;
  createdAt?: string | null;
};

export type ProjectStatusInput = {
  ready?: string | null;
  status?: string | null;
  downloadLink?: string | null;
  code?: string | null;
};

export type ModelServerRenderConditionInput = {
  projectId?: ModelIDInput | null;
  scenes?: ModelStringInput | null;
  data?: ModelStringInput | null;
  env?: ModelStringInput | null;
  outputFileName?: ModelStringInput | null;
  quality?: ModelIntInput | null;
  frameToStart?: ModelIntInput | null;
  frameToEnd?: ModelIntInput | null;
  format?: ModelStringInput | null;
  cognitoUserIdentifier?: ModelStringInput | null;
  cognitoGroupOwner?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  and?: Array<ModelServerRenderConditionInput | null> | null;
  or?: Array<ModelServerRenderConditionInput | null> | null;
  not?: ModelServerRenderConditionInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateServerRenderInput = {
  id: string;
  projectId?: string | null;
  scenes?: Array<string> | null;
  data?: string | null;
  env?: string | null;
  outputFileName?: string | null;
  quality?: number | null;
  frameToStart?: number | null;
  frameToEnd?: number | null;
  format?: string | null;
  status?: ProjectStatusInput | null;
  cognitoUserIdentifier?: string | null;
  cognitoGroupOwner?: string | null;
  createdAt?: string | null;
};

export type DeleteServerRenderInput = {
  id: string;
};

export type CreateUseCaseInput = {
  id?: string | null;
  name: string;
  projectId: string;
  images?: Array<string> | null;
  shortDescription?: string | null;
  longDescription?: string | null;
  thumbnail?: string | null;
  demoLink?: string | null;
  videoPreview?: string | null;
  lineupId?: string | null;
  lineupsIds?: Array<string> | null;
  scenes?: Array<string> | null;
  liveControl?: string | null;
  liveControlSchema?: string | null;
  dynamicDataSchema?: string | null;
  categoryId?: string | null;
};

export type ModelUseCaseConditionInput = {
  name?: ModelStringInput | null;
  projectId?: ModelIDInput | null;
  images?: ModelStringInput | null;
  shortDescription?: ModelStringInput | null;
  longDescription?: ModelStringInput | null;
  thumbnail?: ModelStringInput | null;
  demoLink?: ModelStringInput | null;
  videoPreview?: ModelStringInput | null;
  lineupId?: ModelStringInput | null;
  lineupsIds?: ModelStringInput | null;
  scenes?: ModelStringInput | null;
  liveControl?: ModelStringInput | null;
  liveControlSchema?: ModelStringInput | null;
  dynamicDataSchema?: ModelStringInput | null;
  categoryId?: ModelIDInput | null;
  and?: Array<ModelUseCaseConditionInput | null> | null;
  or?: Array<ModelUseCaseConditionInput | null> | null;
  not?: ModelUseCaseConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateUseCaseInput = {
  id: string;
  name?: string | null;
  projectId?: string | null;
  images?: Array<string> | null;
  shortDescription?: string | null;
  longDescription?: string | null;
  thumbnail?: string | null;
  demoLink?: string | null;
  videoPreview?: string | null;
  lineupId?: string | null;
  lineupsIds?: Array<string> | null;
  scenes?: Array<string> | null;
  liveControl?: string | null;
  liveControlSchema?: string | null;
  dynamicDataSchema?: string | null;
  categoryId?: string | null;
};

export type DeleteUseCaseInput = {
  id: string;
};

export type CreateUseCaseTagInput = {
  tag: string;
  useCaseIds: Array<string>;
};

export type ModelUseCaseTagConditionInput = {
  useCaseIds?: ModelStringInput | null;
  and?: Array<ModelUseCaseTagConditionInput | null> | null;
  or?: Array<ModelUseCaseTagConditionInput | null> | null;
  not?: ModelUseCaseTagConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UseCaseTag = {
  __typename: "UseCaseTag";
  tag: string;
  useCaseIds: Array<string>;
  createdAt: string;
  updatedAt: string;
};

export type UpdateUseCaseTagInput = {
  tag: string;
  useCaseIds?: Array<string> | null;
};

export type DeleteUseCaseTagInput = {
  tag: string;
};

export type CreateUseCaseCategoryInput = {
  id?: string | null;
  name: string;
  description: string;
  thumbnail: string;
};

export type ModelUseCaseCategoryConditionInput = {
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  thumbnail?: ModelStringInput | null;
  and?: Array<ModelUseCaseCategoryConditionInput | null> | null;
  or?: Array<ModelUseCaseCategoryConditionInput | null> | null;
  not?: ModelUseCaseCategoryConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateUseCaseCategoryInput = {
  id: string;
  name?: string | null;
  description?: string | null;
  thumbnail?: string | null;
};

export type DeleteUseCaseCategoryInput = {
  id: string;
};

export type CreateUserInput = {
  id?: string | null;
  email?: string | null;
  name?: string | null;
  lastName?: string | null;
  picture?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ModelUserConditionInput = {
  email?: ModelStringInput | null;
  name?: ModelStringInput | null;
  lastName?: ModelStringInput | null;
  picture?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelUserConditionInput | null> | null;
  or?: Array<ModelUserConditionInput | null> | null;
  not?: ModelUserConditionInput | null;
  id?: ModelStringInput | null;
};

export type UpdateUserInput = {
  id: string;
  email?: string | null;
  name?: string | null;
  lastName?: string | null;
  picture?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type DeleteUserInput = {
  id: string;
};

export type CreateAccountSceneLibrariesInput = {
  id?: string | null;
  accountID: string;
  sceneLibraryID: string;
};

export type ModelAccountSceneLibrariesConditionInput = {
  accountID?: ModelIDInput | null;
  sceneLibraryID?: ModelIDInput | null;
  and?: Array<ModelAccountSceneLibrariesConditionInput | null> | null;
  or?: Array<ModelAccountSceneLibrariesConditionInput | null> | null;
  not?: ModelAccountSceneLibrariesConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateAccountSceneLibrariesInput = {
  id: string;
  accountID?: string | null;
  sceneLibraryID?: string | null;
};

export type DeleteAccountSceneLibrariesInput = {
  id: string;
};

export type CreateProjectSceneLibrariesInput = {
  id?: string | null;
  projectID: string;
  sceneLibraryID: string;
};

export type ModelProjectSceneLibrariesConditionInput = {
  projectID?: ModelIDInput | null;
  sceneLibraryID?: ModelIDInput | null;
  and?: Array<ModelProjectSceneLibrariesConditionInput | null> | null;
  or?: Array<ModelProjectSceneLibrariesConditionInput | null> | null;
  not?: ModelProjectSceneLibrariesConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateProjectSceneLibrariesInput = {
  id: string;
  projectID?: string | null;
  sceneLibraryID?: string | null;
};

export type DeleteProjectSceneLibrariesInput = {
  id: string;
};

export type CreateUseCaseSceneLibrariesInput = {
  id?: string | null;
  sceneLibraryID: string;
  useCaseID: string;
};

export type ModelUseCaseSceneLibrariesConditionInput = {
  sceneLibraryID?: ModelIDInput | null;
  useCaseID?: ModelIDInput | null;
  and?: Array<ModelUseCaseSceneLibrariesConditionInput | null> | null;
  or?: Array<ModelUseCaseSceneLibrariesConditionInput | null> | null;
  not?: ModelUseCaseSceneLibrariesConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type UpdateUseCaseSceneLibrariesInput = {
  id: string;
  sceneLibraryID?: string | null;
  useCaseID?: string | null;
};

export type DeleteUseCaseSceneLibrariesInput = {
  id: string;
};

export type CreateProjectInput = {
  id?: string | null;
  projectAccountId: string;
  title: string;
  videoParts?: Array<VidPartInput> | null;
  allowCreateDataPoint?: boolean | null;
  allowDataConnect?: boolean | null;
  allowCrmConnect?: boolean | null;
  allowSdkConnect?: boolean | null;
  allowSendFormData?: boolean | null;
  analyticsReportUrl?: string | null;
  createdAt?: string | null;
  dataFiles?: Array<DataFileInput | null> | null;
  description?: string | null;
  fileName?: string | null;
  jsonChanges?: string | null;
  jsonVidUrl?: string | null;
  playerSettings?: PlayerSettingsInput | null;
  settings?: string | null;
  stateJsonSchemaStr?: string | null;
  settingsJsonSchemaStr?: string | null;
  thumbS3Url?: string | null;
  experiments?: Array<ExperimentInput> | null;
  analyticsEnabled?: boolean | null;
  owner?: string | null;
  aliasId: string;
  minisiteConfigs?: Array<MinisiteConfigInput> | null;
  playerVersionToUse?: string | null;
  customHtml?: string | null;
  dynamicThumbnails?: Array<DynamicThumbnailInput | null> | null;
  textToVideoScript?: string | null;
};

export type DataFileInput = {
  fileName?: string | null;
  tag?: string | null;
  createdAt?: string | null;
};

export type MinisiteConfigInput = {
  scenes?: Array<string> | null;
  title?: string | null;
  description?: string | null;
  thumbUrl?: string | null;
  faviconUrl?: string | null;
  preCreate?: string | null;
};

export type DynamicThumbnailInput = {
  id: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  name?: string | null;
};

export type UpdateProjectInput = {
  id: string;
  projectAccountId?: string | null;
  title?: string | null;
  videoParts?: Array<VidPartInput> | null;
  allowCreateDataPoint?: boolean | null;
  allowDataConnect?: boolean | null;
  allowCrmConnect?: boolean | null;
  allowSdkConnect?: boolean | null;
  analyticsReportUrl?: string | null;
  createdAt?: string | null;
  dataFiles?: Array<DataFileInput | null> | null;
  description?: string | null;
  fileName?: string | null;
  jsonChanges?: string | null;
  jsonVidUrl?: string | null;
  playerSettings?: PlayerSettingsInput | null;
  settings?: string | null;
  stateJsonSchemaStr?: string | null;
  settingsJsonSchemaStr?: string | null;
  thumbS3Url?: string | null;
  analyticsEnabled?: boolean | null;
  experiments?: Array<ExperimentInput> | null;
  flowDiagram?: FlowDiagramInput | null;
  nodeLayout?: NodeLayoutMapInput | null;
  experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
  owner?: string | null;
  aliasId?: string | null;
  minisiteConfigs?: Array<MinisiteConfigInput> | null;
  playerVersionToUse?: string | null;
  customHtml?: string | null;
  dynamicThumbnails?: Array<DynamicThumbnailInput | null> | null;
  publishedAt?: string | null;
  textToVideoScript?: string | null;
  overlay?: OverlayInput | null;
  fontOverrides?: Array<FontInput> | null;
  isDeleted?: boolean | null;
  fontMap?: Array<FontMapInput> | null;
};

export type UpdateProjectVersionInput = {
  id: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  videoParts?: Array<VidPartInput> | null;
  stateJsonSchemaStr?: string | null;
  settingsJsonSchemaStr?: string | null;
  experiments?: Array<ExperimentInput> | null;
  experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
  settings?: string | null;
  owner?: string | null;
  playerVersionToUse?: string | null;
  accountOwner?: string | null;
  textToVideoScript?: string | null;
  flowDiagram?: FlowDiagramInput | null;
  nodeLayout?: NodeLayoutMapInput | null;
  overlay?: OverlayInput | null;
  fontOverrides?: Array<FontInput> | null;
  playerSettings?: PlayerSettingsInput | null;
  fontMap?: Array<FontMapInput> | null;
  projectProjectVersionsId?: string | null;
};

export type SendInstantNotificationInput = {
  type: string;
  subType?: string | null;
  status: NotificationStatus;
  title: string;
  message: string;
  owner: string;
  projectId?: string | null;
  extra?: string | null;
};

export type InstantNotification = {
  __typename: "InstantNotification";
  type: string;
  subType?: string | null;
  status: NotificationStatus;
  title: string;
  message: string;
  owner: string;
  projectId?: string | null;
  extra?: string | null;
};

export type ByAccountInput = {
  projectAccountId: string;
  nextToken?: string | null;
  limit?: number | null;
};

export type ByAccountOutput = {
  __typename: "ByAccountOutput";
  items: Array<Project | null>;
  nextToken?: string | null;
};

export type ModelAccountFilterInput = {
  id?: ModelIDInput | null;
  gid?: ModelStringInput | null;
  name?: ModelStringInput | null;
  aliasId?: ModelStringInput | null;
  minisiteDomain?: ModelStringInput | null;
  mfaEnabled?: ModelBooleanInput | null;
  ownerId?: ModelIDInput | null;
  accountUsageType?: ModelStringInput | null;
  companySize?: ModelStringInput | null;
  tierId?: ModelIDInput | null;
  stripeCustomerId?: ModelStringInput | null;
  createNewVideosWithBlingLogo?: ModelBooleanInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelAccountFilterInput | null> | null;
  or?: Array<ModelAccountFilterInput | null> | null;
  not?: ModelAccountFilterInput | null;
};

export type ModelAccountConnection = {
  __typename: "ModelAccountConnection";
  items: Array<Account | null>;
  nextToken?: string | null;
};

export type ModelIDKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export type ModelAccountUserFilterInput = {
  id?: ModelIDInput | null;
  email?: ModelStringInput | null;
  accountId?: ModelIDInput | null;
  userId?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  workType?: ModelStringInput | null;
  roleInCompany?: ModelStringInput | null;
  permissions?: ModelStringInput | null;
  and?: Array<ModelAccountUserFilterInput | null> | null;
  or?: Array<ModelAccountUserFilterInput | null> | null;
  not?: ModelAccountUserFilterInput | null;
};

export type ModelInviteFilterInput = {
  id?: ModelIDInput | null;
  senderId?: ModelIDInput | null;
  email?: ModelStringInput | null;
  accountId?: ModelIDInput | null;
  confirmCode?: ModelStringInput | null;
  confirmed?: ModelBooleanInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  permissions?: ModelStringInput | null;
  and?: Array<ModelInviteFilterInput | null> | null;
  or?: Array<ModelInviteFilterInput | null> | null;
  not?: ModelInviteFilterInput | null;
};

export type ModelInviteConnection = {
  __typename: "ModelInviteConnection";
  items: Array<Invite | null>;
  nextToken?: string | null;
};

export type ModelTierFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  monthlyPrice?: ModelStringInput | null;
  annualPrice?: ModelStringInput | null;
  description?: ModelStringInput | null;
  enabled?: ModelBooleanInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelTierFilterInput | null> | null;
  or?: Array<ModelTierFilterInput | null> | null;
  not?: ModelTierFilterInput | null;
};

export type ModelTierConnection = {
  __typename: "ModelTierConnection";
  items: Array<Tier | null>;
  nextToken?: string | null;
};

export type ModelFeatureFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  enabled?: ModelBooleanInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelFeatureFilterInput | null> | null;
  or?: Array<ModelFeatureFilterInput | null> | null;
  not?: ModelFeatureFilterInput | null;
};

export type ModelFeatureConnection = {
  __typename: "ModelFeatureConnection";
  items: Array<Feature | null>;
  nextToken?: string | null;
};

export type ModelTierFeatureFilterInput = {
  id?: ModelIDInput | null;
  tierId?: ModelIDInput | null;
  featureId?: ModelIDInput | null;
  description?: ModelStringInput | null;
  limitValue?: ModelIntInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelTierFeatureFilterInput | null> | null;
  or?: Array<ModelTierFeatureFilterInput | null> | null;
  not?: ModelTierFeatureFilterInput | null;
};

export type ModelAccountFeatureOverrideFilterInput = {
  id?: ModelIDInput | null;
  accountId?: ModelIDInput | null;
  featureId?: ModelIDInput | null;
  reason?: ModelStringInput | null;
  limitValue?: ModelIntInput | null;
  enabled?: ModelBooleanInput | null;
  expiresAt?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelAccountFeatureOverrideFilterInput | null> | null;
  or?: Array<ModelAccountFeatureOverrideFilterInput | null> | null;
  not?: ModelAccountFeatureOverrideFilterInput | null;
};

export type ModelFormDataFilterInput = {
  id?: ModelIDInput | null;
  accountOwner?: ModelStringInput | null;
  projectFormDataId?: ModelIDInput | null;
  data?: ModelStringInput | null;
  sessionId?: ModelStringInput | null;
  userId?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelFormDataFilterInput | null> | null;
  or?: Array<ModelFormDataFilterInput | null> | null;
  not?: ModelFormDataFilterInput | null;
};

export type ModelStringKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export type ModelNotificationFilterInput = {
  id?: ModelIDInput | null;
  type?: ModelStringInput | null;
  subType?: ModelStringInput | null;
  status?: ModelNotificationStatusInput | null;
  title?: ModelStringInput | null;
  message?: ModelStringInput | null;
  read?: ModelBooleanInput | null;
  owner?: ModelStringInput | null;
  projectId?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  extra?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelNotificationFilterInput | null> | null;
  or?: Array<ModelNotificationFilterInput | null> | null;
  not?: ModelNotificationFilterInput | null;
  projectNotificationsId?: ModelIDInput | null;
};

export type ModelProjectFilterInput = {
  id?: ModelIDInput | null;
  projectAccountId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  allowCreateDataPoint?: ModelBooleanInput | null;
  allowDataConnect?: ModelBooleanInput | null;
  allowCrmConnect?: ModelBooleanInput | null;
  allowSdkConnect?: ModelBooleanInput | null;
  allowSendFormData?: ModelBooleanInput | null;
  analyticsReportUrl?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  description?: ModelStringInput | null;
  fileName?: ModelStringInput | null;
  jsonChanges?: ModelStringInput | null;
  jsonVidUrl?: ModelStringInput | null;
  settings?: ModelStringInput | null;
  stateJsonSchemaStr?: ModelStringInput | null;
  settingsJsonSchemaStr?: ModelStringInput | null;
  thumbS3Url?: ModelStringInput | null;
  experimentOptimizationTechnique?: ModelExperimentOptimizationTechniqueInput | null;
  analyticsEnabled?: ModelBooleanInput | null;
  owner?: ModelStringInput | null;
  aliasId?: ModelStringInput | null;
  playerVersionToUse?: ModelStringInput | null;
  customHtml?: ModelStringInput | null;
  publishedAt?: ModelStringInput | null;
  allowedOrigins?: ModelStringInput | null;
  textToVideoScript?: ModelStringInput | null;
  instantiatedFromUseCase?: ModelIDInput | null;
  isDeleted?: ModelBooleanInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelProjectFilterInput | null> | null;
  or?: Array<ModelProjectFilterInput | null> | null;
  not?: ModelProjectFilterInput | null;
};

export type ProjectChangeActivity = {
  __typename: "ProjectChangeActivity";
  projectId: string;
  before?: ProjectDataChangeActivity | null;
  after?: ProjectDataChangeActivity | null;
  owner?: string | null;
  email?: string | null;
  origin?: string | null;
  accountOwner: string;
  createdAt: string;
  id: string;
  updatedAt: string;
};

export type ProjectDataChangeActivity = {
  __typename: "ProjectDataChangeActivity";
  projectAccountId?: string | null;
  title?: string | null;
  videoParts?: Array<VidPart | null> | null;
  allowCreateDataPoint?: boolean | null;
  allowDataConnect?: boolean | null;
  allowCrmConnect?: boolean | null;
  allowSdkConnect?: boolean | null;
  analyticsReportUrl?: string | null;
  createdAt?: string | null;
  dataFiles?: Array<DataFile | null> | null;
  description?: string | null;
  fileName?: string | null;
  jsonChanges?: string | null;
  jsonVidUrl?: string | null;
  playerSettings?: PlayerSettings | null;
  settings?: string | null;
  stateJsonSchemaStr?: string | null;
  settingsJsonSchemaStr?: string | null;
  thumbS3Url?: string | null;
  experiments?: Array<Experiment> | null;
  experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
  type: string;
  owner?: string | null;
};

export type ModelProjectChangeActivityFilterInput = {
  projectId?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  email?: ModelStringInput | null;
  origin?: ModelStringInput | null;
  accountOwner?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  id?: ModelIDInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelProjectChangeActivityFilterInput | null> | null;
  or?: Array<ModelProjectChangeActivityFilterInput | null> | null;
  not?: ModelProjectChangeActivityFilterInput | null;
};

export type ModelProjectChangeActivityConnection = {
  __typename: "ModelProjectChangeActivityConnection";
  items: Array<ProjectChangeActivity | null>;
  nextToken?: string | null;
};

export type ProjectVersionChangeActivity = {
  __typename: "ProjectVersionChangeActivity";
  projectId: string;
  before?: ProjectDataChangeActivity | null;
  after?: ProjectDataChangeActivity | null;
  owner?: string | null;
  origin?: string | null;
  accountOwner: string;
  createdAt: string;
  id: string;
  updatedAt: string;
};

export type ModelProjectVersionChangeActivityFilterInput = {
  projectId?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  origin?: ModelStringInput | null;
  accountOwner?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  id?: ModelIDInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelProjectVersionChangeActivityFilterInput | null> | null;
  or?: Array<ModelProjectVersionChangeActivityFilterInput | null> | null;
  not?: ModelProjectVersionChangeActivityFilterInput | null;
};

export type ModelProjectVersionChangeActivityConnection = {
  __typename: "ModelProjectVersionChangeActivityConnection";
  items: Array<ProjectVersionChangeActivity | null>;
  nextToken?: string | null;
};

export type ModelProjectVersionFilterInput = {
  id?: ModelIDInput | null;
  accountOwner?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  stateJsonSchemaStr?: ModelStringInput | null;
  settingsJsonSchemaStr?: ModelStringInput | null;
  settings?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  playerVersionToUse?: ModelStringInput | null;
  experimentOptimizationTechnique?: ModelExperimentOptimizationTechniqueInput | null;
  textToVideoScript?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  and?: Array<ModelProjectVersionFilterInput | null> | null;
  or?: Array<ModelProjectVersionFilterInput | null> | null;
  not?: ModelProjectVersionFilterInput | null;
  projectProjectVersionsId?: ModelIDInput | null;
};

export type ModelSceneLibraryFilterInput = {
  id?: ModelIDInput | null;
  title?: ModelStringInput | null;
  vibe?: ModelStringInput | null;
  projectId?: ModelIDInput | null;
  description?: ModelStringInput | null;
  thumbnail?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelSceneLibraryFilterInput | null> | null;
  or?: Array<ModelSceneLibraryFilterInput | null> | null;
  not?: ModelSceneLibraryFilterInput | null;
};

export type ModelSceneLibraryConnection = {
  __typename: "ModelSceneLibraryConnection";
  items: Array<SceneLibrary | null>;
  nextToken?: string | null;
};

export type ModelServerRenderFilterInput = {
  id?: ModelIDInput | null;
  projectId?: ModelIDInput | null;
  scenes?: ModelStringInput | null;
  data?: ModelStringInput | null;
  env?: ModelStringInput | null;
  outputFileName?: ModelStringInput | null;
  quality?: ModelIntInput | null;
  frameToStart?: ModelIntInput | null;
  frameToEnd?: ModelIntInput | null;
  format?: ModelStringInput | null;
  cognitoUserIdentifier?: ModelStringInput | null;
  cognitoGroupOwner?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelServerRenderFilterInput | null> | null;
  or?: Array<ModelServerRenderFilterInput | null> | null;
  not?: ModelServerRenderFilterInput | null;
};

export type ModelUseCaseFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  projectId?: ModelIDInput | null;
  images?: ModelStringInput | null;
  shortDescription?: ModelStringInput | null;
  longDescription?: ModelStringInput | null;
  thumbnail?: ModelStringInput | null;
  demoLink?: ModelStringInput | null;
  videoPreview?: ModelStringInput | null;
  lineupId?: ModelStringInput | null;
  lineupsIds?: ModelStringInput | null;
  scenes?: ModelStringInput | null;
  liveControl?: ModelStringInput | null;
  liveControlSchema?: ModelStringInput | null;
  dynamicDataSchema?: ModelStringInput | null;
  categoryId?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelUseCaseFilterInput | null> | null;
  or?: Array<ModelUseCaseFilterInput | null> | null;
  not?: ModelUseCaseFilterInput | null;
};

export type ModelUseCaseTagFilterInput = {
  tag?: ModelStringInput | null;
  useCaseIds?: ModelStringInput | null;
  id?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelUseCaseTagFilterInput | null> | null;
  or?: Array<ModelUseCaseTagFilterInput | null> | null;
  not?: ModelUseCaseTagFilterInput | null;
};

export type ModelUseCaseTagConnection = {
  __typename: "ModelUseCaseTagConnection";
  items: Array<UseCaseTag | null>;
  nextToken?: string | null;
};

export type ModelUseCaseCategoryFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  thumbnail?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelUseCaseCategoryFilterInput | null> | null;
  or?: Array<ModelUseCaseCategoryFilterInput | null> | null;
  not?: ModelUseCaseCategoryFilterInput | null;
};

export type ModelUseCaseCategoryConnection = {
  __typename: "ModelUseCaseCategoryConnection";
  items: Array<UseCaseCategory | null>;
  nextToken?: string | null;
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null;
  email?: ModelStringInput | null;
  name?: ModelStringInput | null;
  lastName?: ModelStringInput | null;
  picture?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelUserFilterInput | null> | null;
  or?: Array<ModelUserFilterInput | null> | null;
  not?: ModelUserFilterInput | null;
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection";
  items: Array<User | null>;
  nextToken?: string | null;
};

export type ModelAccountSceneLibrariesFilterInput = {
  id?: ModelIDInput | null;
  accountID?: ModelIDInput | null;
  sceneLibraryID?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelAccountSceneLibrariesFilterInput | null> | null;
  or?: Array<ModelAccountSceneLibrariesFilterInput | null> | null;
  not?: ModelAccountSceneLibrariesFilterInput | null;
};

export type ModelProjectSceneLibrariesFilterInput = {
  id?: ModelIDInput | null;
  projectID?: ModelIDInput | null;
  sceneLibraryID?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelProjectSceneLibrariesFilterInput | null> | null;
  or?: Array<ModelProjectSceneLibrariesFilterInput | null> | null;
  not?: ModelProjectSceneLibrariesFilterInput | null;
};

export type ModelUseCaseSceneLibrariesFilterInput = {
  id?: ModelIDInput | null;
  sceneLibraryID?: ModelIDInput | null;
  useCaseID?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelUseCaseSceneLibrariesFilterInput | null> | null;
  or?: Array<ModelUseCaseSceneLibrariesFilterInput | null> | null;
  not?: ModelUseCaseSceneLibrariesFilterInput | null;
};

export type ModelSubscriptionNotificationFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  type?: ModelSubscriptionStringInput | null;
  subType?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  title?: ModelSubscriptionStringInput | null;
  message?: ModelSubscriptionStringInput | null;
  read?: ModelSubscriptionBooleanInput | null;
  projectId?: ModelSubscriptionIDInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  extra?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionNotificationFilterInput | null> | null;
  or?: Array<ModelSubscriptionNotificationFilterInput | null> | null;
  owner?: ModelStringInput | null;
};

export type ModelSubscriptionIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
};

export type ModelSubscriptionAccountSceneLibrariesFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  accountID?: ModelSubscriptionIDInput | null;
  sceneLibraryID?: ModelSubscriptionIDInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionAccountSceneLibrariesFilterInput | null> | null;
  or?: Array<ModelSubscriptionAccountSceneLibrariesFilterInput | null> | null;
};

export type ModelSubscriptionProjectSceneLibrariesFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  projectID?: ModelSubscriptionIDInput | null;
  sceneLibraryID?: ModelSubscriptionIDInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionProjectSceneLibrariesFilterInput | null> | null;
  or?: Array<ModelSubscriptionProjectSceneLibrariesFilterInput | null> | null;
};

export type ModelSubscriptionUseCaseSceneLibrariesFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  sceneLibraryID?: ModelSubscriptionIDInput | null;
  useCaseID?: ModelSubscriptionIDInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionUseCaseSceneLibrariesFilterInput | null> | null;
  or?: Array<ModelSubscriptionUseCaseSceneLibrariesFilterInput | null> | null;
};

export type CustomGetAccountQueryVariables = {
  id: string;
};

export type CustomGetAccountQuery = {
  getAccount?: {
    __typename: "Account";
    id: string;
    gid: string;
    name: string;
    accountType?: {
      __typename: "AccountType";
      levelName: AccountTypeName;
    } | null;
    mfaEnabled?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CustomGetUserQueryVariables = {
  id: string;
  accountsLimit?: number | null;
  accountsNextToken?: string | null;
};

export type CustomGetUserQuery = {
  getUser?: {
    __typename: "User";
    id: string;
    email?: string | null;
    name?: string | null;
    picture?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    accounts?: {
      __typename: "ModelAccountUserConnection";
      items: Array<{
        __typename: "AccountUser";
        id: string;
        accountId: string;
        userId: string;
        createdAt: string;
        updatedAt: string;
        permissions?: Array<string | null> | null;
        account?: {
          __typename: "Account";
          id: string;
          gid: string;
          name: string;
          mfaEnabled?: boolean | null;
          createdAt: string;
          updatedAt: string;
          tierId: string;
          accountType?: {
            __typename: "AccountType";
            levelName: AccountTypeName;
          } | null;
          fonts?: Array<{
            __typename: "AccountFont";
            fontFamily: string;
            variants: Array<{
              __typename: "FontVariant";
              name: string;
              weight: number;
              style: string;
              url?: string | null;
            }>;
          } | null> | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
  } | null;
};

export type CustomGetProjectQueryVariables = {
  id: string;
};

export type CustomGetProjectQuery = {
  getProject?: {
    __typename: "Project";
    id: string;
    projectAccountId: string;
    title: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      tierId: string;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      modsArr?: Array<{
        __typename: "Mod";
        id: number;
        dataStr: string;
        origin?: string | null;
        name?: string | null;
        description?: string | null;
      }> | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    allowCreateDataPoint?: boolean | null;
    allowDataConnect?: boolean | null;
    allowCrmConnect?: boolean | null;
    allowSdkConnect?: boolean | null;
    allowSendFormData?: boolean | null;
    analyticsReportUrl?: string | null;
    createdAt?: string | null;
    dataFiles?: Array<{
      __typename: "DataFile";
      fileName?: string | null;
      tag?: string | null;
      createdAt?: string | null;
    } | null> | null;
    description?: string | null;
    fileName?: string | null;
    jsonChanges?: string | null;
    jsonVidUrl?: string | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    projectVersions?: {
      __typename: "ModelProjectVersionConnection";
      nextToken?: string | null;
    } | null;
    settings?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    thumbS3Url?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
      variants?: Array<{
        __typename: "Variant";
        id: string;
        value: string;
        successFactors: {
          __typename: "SuccessFactors";
          conversionSuccessData: number;
          engagementSuccessData: number;
          selectionCount: number;
          watchTimeSuccessData: number;
        };
      }> | null;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    analyticsEnabled?: boolean | null;
    owner?: string | null;
    aliasId: string;
    minisiteConfigs?: Array<{
      __typename: "MinisiteConfig";
      scenes?: Array<string> | null;
      title?: string | null;
      description?: string | null;
      thumbUrl?: string | null;
      faviconUrl?: string | null;
      preCreate?: string | null;
    }> | null;
    playerVersionToUse?: string | null;
    customHtml?: string | null;
    dynamicThumbnails?: Array<{
      __typename: "DynamicThumbnail";
      name?: string | null;
      id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    publishedAt?: string | null;
    allowedOrigins?: Array<string | null> | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
      nodes: Array<{
        __typename: "FlowNode";
        id: string;
        label: string;
        data?: string | null;
        lineupId?: string | null;
        type: FlowNodeType;
      }>;
      edges: Array<{
        __typename: "FlowEdge";
        source: string;
        target: string;
        sourceHandle?: string | null;
      }>;
    } | null;
    textToVideoScript?: string | null;
    instantiatedFromUseCase?: string | null;
    overlay?: {
      __typename: "Overlay";
      audio?: Array<{
        __typename: "OverlayAudio";
        url: string;
        volume?: number | null;
        loop?: boolean | null;
      }> | null;
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    isDeleted?: boolean | null;
    updatedAt: string;
  } | null;
};

export type CreateAccountMutationVariables = {
  input: CreateAccountInput;
  condition?: ModelAccountConditionInput | null;
};

export type CreateAccountMutation = {
  createAccount?: {
    __typename: "Account";
    id: string;
    gid: string;
    name: string;
    projects?: {
      __typename: "ModelProjectConnection";
      nextToken?: string | null;
    } | null;
    fileuploads?: Array<{
      __typename: "FileUpload";
      originalName?: string | null;
      createdAt: string;
      fileName: string;
      fileStatus?: string | null;
      fileError?: string | null;
      numRecords?: number | null;
      numErrors?: number | null;
      totalRecords?: number | null;
      writtenRecords?: number | null;
    }> | null;
    integrations?: {
      __typename: "Integrations";
      hubspot?: string | null;
    } | null;
    aliasId: string;
    fonts?: Array<{
      __typename: "AccountFont";
      fontFamily: string;
    }> | null;
    minisiteDomain?: string | null;
    mfaEnabled?: boolean | null;
    ownerId?: string | null;
    users?: {
      __typename: "ModelAccountUserConnection";
      nextToken?: string | null;
    } | null;
    accountUsageType?: string | null;
    companySize?: string | null;
    tierId: string;
    tier?: {
      __typename: "Tier";
      id: string;
      name: string;
      monthlyPrice: string;
      annualPrice: string;
      description: string;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
    stripeCustomerId?: string | null;
    featureOverrides?: {
      __typename: "ModelAccountFeatureOverrideConnection";
      nextToken?: string | null;
    } | null;
    createNewVideosWithBlingLogo?: boolean | null;
    accountType?: {
      __typename: "AccountType";
      levelName: AccountTypeName;
    } | null;
    currentBillingPeriod?: {
      __typename: "BillingPeriod";
      startDate: string;
      endDate: string;
    } | null;
    ppvCurrentBillingPeriod?: {
      __typename: "BillingPeriod";
      startDate: string;
      endDate: string;
    } | null;
    availableSceneLibraries?: {
      __typename: "ModelAccountSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateAccountMutationVariables = {
  input: UpdateAccountInput;
  condition?: ModelAccountConditionInput | null;
};

export type UpdateAccountMutation = {
  updateAccount?: {
    __typename: "Account";
    id: string;
    gid: string;
    name: string;
    projects?: {
      __typename: "ModelProjectConnection";
      nextToken?: string | null;
    } | null;
    fileuploads?: Array<{
      __typename: "FileUpload";
      originalName?: string | null;
      createdAt: string;
      fileName: string;
      fileStatus?: string | null;
      fileError?: string | null;
      numRecords?: number | null;
      numErrors?: number | null;
      totalRecords?: number | null;
      writtenRecords?: number | null;
    }> | null;
    integrations?: {
      __typename: "Integrations";
      hubspot?: string | null;
    } | null;
    aliasId: string;
    fonts?: Array<{
      __typename: "AccountFont";
      fontFamily: string;
    }> | null;
    minisiteDomain?: string | null;
    mfaEnabled?: boolean | null;
    ownerId?: string | null;
    users?: {
      __typename: "ModelAccountUserConnection";
      nextToken?: string | null;
    } | null;
    accountUsageType?: string | null;
    companySize?: string | null;
    tierId: string;
    tier?: {
      __typename: "Tier";
      id: string;
      name: string;
      monthlyPrice: string;
      annualPrice: string;
      description: string;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
    stripeCustomerId?: string | null;
    featureOverrides?: {
      __typename: "ModelAccountFeatureOverrideConnection";
      nextToken?: string | null;
    } | null;
    createNewVideosWithBlingLogo?: boolean | null;
    accountType?: {
      __typename: "AccountType";
      levelName: AccountTypeName;
    } | null;
    currentBillingPeriod?: {
      __typename: "BillingPeriod";
      startDate: string;
      endDate: string;
    } | null;
    ppvCurrentBillingPeriod?: {
      __typename: "BillingPeriod";
      startDate: string;
      endDate: string;
    } | null;
    availableSceneLibraries?: {
      __typename: "ModelAccountSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteAccountMutationVariables = {
  input: DeleteAccountInput;
  condition?: ModelAccountConditionInput | null;
};

export type DeleteAccountMutation = {
  deleteAccount?: {
    __typename: "Account";
    id: string;
    gid: string;
    name: string;
    projects?: {
      __typename: "ModelProjectConnection";
      nextToken?: string | null;
    } | null;
    fileuploads?: Array<{
      __typename: "FileUpload";
      originalName?: string | null;
      createdAt: string;
      fileName: string;
      fileStatus?: string | null;
      fileError?: string | null;
      numRecords?: number | null;
      numErrors?: number | null;
      totalRecords?: number | null;
      writtenRecords?: number | null;
    }> | null;
    integrations?: {
      __typename: "Integrations";
      hubspot?: string | null;
    } | null;
    aliasId: string;
    fonts?: Array<{
      __typename: "AccountFont";
      fontFamily: string;
    }> | null;
    minisiteDomain?: string | null;
    mfaEnabled?: boolean | null;
    ownerId?: string | null;
    users?: {
      __typename: "ModelAccountUserConnection";
      nextToken?: string | null;
    } | null;
    accountUsageType?: string | null;
    companySize?: string | null;
    tierId: string;
    tier?: {
      __typename: "Tier";
      id: string;
      name: string;
      monthlyPrice: string;
      annualPrice: string;
      description: string;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
    stripeCustomerId?: string | null;
    featureOverrides?: {
      __typename: "ModelAccountFeatureOverrideConnection";
      nextToken?: string | null;
    } | null;
    createNewVideosWithBlingLogo?: boolean | null;
    accountType?: {
      __typename: "AccountType";
      levelName: AccountTypeName;
    } | null;
    currentBillingPeriod?: {
      __typename: "BillingPeriod";
      startDate: string;
      endDate: string;
    } | null;
    ppvCurrentBillingPeriod?: {
      __typename: "BillingPeriod";
      startDate: string;
      endDate: string;
    } | null;
    availableSceneLibraries?: {
      __typename: "ModelAccountSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateInviteMutationVariables = {
  input: CreateInviteInput;
  condition?: ModelInviteConditionInput | null;
};

export type CreateInviteMutation = {
  createInvite?: {
    __typename: "Invite";
    id: string;
    senderId: string;
    email: string;
    accountId: string;
    account?: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    confirmCode: string;
    confirmed: boolean;
    createdAt: string;
    updatedAt: string;
    permissions?: Array<string | null> | null;
  } | null;
};

export type UpdateInviteMutationVariables = {
  input: UpdateInviteInput;
  condition?: ModelInviteConditionInput | null;
};

export type UpdateInviteMutation = {
  updateInvite?: {
    __typename: "Invite";
    id: string;
    senderId: string;
    email: string;
    accountId: string;
    account?: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    confirmCode: string;
    confirmed: boolean;
    createdAt: string;
    updatedAt: string;
    permissions?: Array<string | null> | null;
  } | null;
};

export type DeleteInviteMutationVariables = {
  input: DeleteInviteInput;
  condition?: ModelInviteConditionInput | null;
};

export type DeleteInviteMutation = {
  deleteInvite?: {
    __typename: "Invite";
    id: string;
    senderId: string;
    email: string;
    accountId: string;
    account?: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    confirmCode: string;
    confirmed: boolean;
    createdAt: string;
    updatedAt: string;
    permissions?: Array<string | null> | null;
  } | null;
};

export type CreateTierMutationVariables = {
  input: CreateTierInput;
  condition?: ModelTierConditionInput | null;
};

export type CreateTierMutation = {
  createTier?: {
    __typename: "Tier";
    id: string;
    name: string;
    monthlyPrice: string;
    annualPrice: string;
    description: string;
    enabled: boolean;
    features?: {
      __typename: "ModelTierFeatureConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateTierMutationVariables = {
  input: UpdateTierInput;
  condition?: ModelTierConditionInput | null;
};

export type UpdateTierMutation = {
  updateTier?: {
    __typename: "Tier";
    id: string;
    name: string;
    monthlyPrice: string;
    annualPrice: string;
    description: string;
    enabled: boolean;
    features?: {
      __typename: "ModelTierFeatureConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteTierMutationVariables = {
  input: DeleteTierInput;
  condition?: ModelTierConditionInput | null;
};

export type DeleteTierMutation = {
  deleteTier?: {
    __typename: "Tier";
    id: string;
    name: string;
    monthlyPrice: string;
    annualPrice: string;
    description: string;
    enabled: boolean;
    features?: {
      __typename: "ModelTierFeatureConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateFeatureMutationVariables = {
  input: CreateFeatureInput;
  condition?: ModelFeatureConditionInput | null;
};

export type CreateFeatureMutation = {
  createFeature?: {
    __typename: "Feature";
    id: string;
    name: string;
    description?: string | null;
    enabled: boolean;
    tierFeatures?: {
      __typename: "ModelTierFeatureConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateFeatureMutationVariables = {
  input: UpdateFeatureInput;
  condition?: ModelFeatureConditionInput | null;
};

export type UpdateFeatureMutation = {
  updateFeature?: {
    __typename: "Feature";
    id: string;
    name: string;
    description?: string | null;
    enabled: boolean;
    tierFeatures?: {
      __typename: "ModelTierFeatureConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteFeatureMutationVariables = {
  input: DeleteFeatureInput;
  condition?: ModelFeatureConditionInput | null;
};

export type DeleteFeatureMutation = {
  deleteFeature?: {
    __typename: "Feature";
    id: string;
    name: string;
    description?: string | null;
    enabled: boolean;
    tierFeatures?: {
      __typename: "ModelTierFeatureConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateTierFeatureMutationVariables = {
  input: CreateTierFeatureInput;
  condition?: ModelTierFeatureConditionInput | null;
};

export type CreateTierFeatureMutation = {
  createTierFeature?: {
    __typename: "TierFeature";
    id: string;
    tier: {
      __typename: "Tier";
      id: string;
      name: string;
      monthlyPrice: string;
      annualPrice: string;
      description: string;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    };
    tierId: string;
    feature: {
      __typename: "Feature";
      id: string;
      name: string;
      description?: string | null;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    };
    featureId: string;
    description?: string | null;
    limitValue?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateTierFeatureMutationVariables = {
  input: UpdateTierFeatureInput;
  condition?: ModelTierFeatureConditionInput | null;
};

export type UpdateTierFeatureMutation = {
  updateTierFeature?: {
    __typename: "TierFeature";
    id: string;
    tier: {
      __typename: "Tier";
      id: string;
      name: string;
      monthlyPrice: string;
      annualPrice: string;
      description: string;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    };
    tierId: string;
    feature: {
      __typename: "Feature";
      id: string;
      name: string;
      description?: string | null;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    };
    featureId: string;
    description?: string | null;
    limitValue?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteTierFeatureMutationVariables = {
  input: DeleteTierFeatureInput;
  condition?: ModelTierFeatureConditionInput | null;
};

export type DeleteTierFeatureMutation = {
  deleteTierFeature?: {
    __typename: "TierFeature";
    id: string;
    tier: {
      __typename: "Tier";
      id: string;
      name: string;
      monthlyPrice: string;
      annualPrice: string;
      description: string;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    };
    tierId: string;
    feature: {
      __typename: "Feature";
      id: string;
      name: string;
      description?: string | null;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    };
    featureId: string;
    description?: string | null;
    limitValue?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateAccountFeatureOverrideMutationVariables = {
  input: CreateAccountFeatureOverrideInput;
  condition?: ModelAccountFeatureOverrideConditionInput | null;
};

export type CreateAccountFeatureOverrideMutation = {
  createAccountFeatureOverride?: {
    __typename: "AccountFeatureOverride";
    id: string;
    accountId: string;
    featureId: string;
    reason?: string | null;
    limitValue?: number | null;
    enabled: boolean;
    expiresAt?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateAccountFeatureOverrideMutationVariables = {
  input: UpdateAccountFeatureOverrideInput;
  condition?: ModelAccountFeatureOverrideConditionInput | null;
};

export type UpdateAccountFeatureOverrideMutation = {
  updateAccountFeatureOverride?: {
    __typename: "AccountFeatureOverride";
    id: string;
    accountId: string;
    featureId: string;
    reason?: string | null;
    limitValue?: number | null;
    enabled: boolean;
    expiresAt?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteAccountFeatureOverrideMutationVariables = {
  input: DeleteAccountFeatureOverrideInput;
  condition?: ModelAccountFeatureOverrideConditionInput | null;
};

export type DeleteAccountFeatureOverrideMutation = {
  deleteAccountFeatureOverride?: {
    __typename: "AccountFeatureOverride";
    id: string;
    accountId: string;
    featureId: string;
    reason?: string | null;
    limitValue?: number | null;
    enabled: boolean;
    expiresAt?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateFormDataMutationVariables = {
  input: CreateFormDataInput;
  condition?: ModelFormDataConditionInput | null;
};

export type CreateFormDataMutation = {
  createFormData?: {
    __typename: "FormData";
    id: string;
    accountOwner: string;
    projectFormDataId: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    data: string;
    sessionId: string;
    userId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateFormDataMutationVariables = {
  input: UpdateFormDataInput;
  condition?: ModelFormDataConditionInput | null;
};

export type UpdateFormDataMutation = {
  updateFormData?: {
    __typename: "FormData";
    id: string;
    accountOwner: string;
    projectFormDataId: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    data: string;
    sessionId: string;
    userId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteFormDataMutationVariables = {
  input: DeleteFormDataInput;
  condition?: ModelFormDataConditionInput | null;
};

export type DeleteFormDataMutation = {
  deleteFormData?: {
    __typename: "FormData";
    id: string;
    accountOwner: string;
    projectFormDataId: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    data: string;
    sessionId: string;
    userId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateNotificationMutationVariables = {
  input: CreateNotificationInput;
  condition?: ModelNotificationConditionInput | null;
};

export type CreateNotificationMutation = {
  createNotification?: {
    __typename: "Notification";
    id: string;
    type: string;
    subType?: string | null;
    status: NotificationStatus;
    title: string;
    message: string;
    read: boolean;
    owner: string;
    projectId?: string | null;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    createdAt: string;
    extra?: string | null;
    updatedAt: string;
    projectNotificationsId?: string | null;
  } | null;
};

export type UpdateNotificationMutationVariables = {
  input: UpdateNotificationInput;
  condition?: ModelNotificationConditionInput | null;
};

export type UpdateNotificationMutation = {
  updateNotification?: {
    __typename: "Notification";
    id: string;
    type: string;
    subType?: string | null;
    status: NotificationStatus;
    title: string;
    message: string;
    read: boolean;
    owner: string;
    projectId?: string | null;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    createdAt: string;
    extra?: string | null;
    updatedAt: string;
    projectNotificationsId?: string | null;
  } | null;
};

export type DeleteNotificationMutationVariables = {
  input: DeleteNotificationInput;
  condition?: ModelNotificationConditionInput | null;
};

export type DeleteNotificationMutation = {
  deleteNotification?: {
    __typename: "Notification";
    id: string;
    type: string;
    subType?: string | null;
    status: NotificationStatus;
    title: string;
    message: string;
    read: boolean;
    owner: string;
    projectId?: string | null;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    createdAt: string;
    extra?: string | null;
    updatedAt: string;
    projectNotificationsId?: string | null;
  } | null;
};

export type DeleteProjectMutationVariables = {
  input: DeleteProjectInput;
  condition?: ModelProjectConditionInput | null;
};

export type DeleteProjectMutation = {
  deleteProject?: {
    __typename: "Project";
    id: string;
    projectAccountId: string;
    title: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    allowCreateDataPoint?: boolean | null;
    allowDataConnect?: boolean | null;
    allowCrmConnect?: boolean | null;
    allowSdkConnect?: boolean | null;
    allowSendFormData?: boolean | null;
    analyticsReportUrl?: string | null;
    createdAt?: string | null;
    dataFiles?: Array<{
      __typename: "DataFile";
      fileName?: string | null;
      tag?: string | null;
      createdAt?: string | null;
    } | null> | null;
    description?: string | null;
    fileName?: string | null;
    jsonChanges?: string | null;
    jsonVidUrl?: string | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    projectVersions?: {
      __typename: "ModelProjectVersionConnection";
      nextToken?: string | null;
    } | null;
    formData?: {
      __typename: "ModelFormDataConnection";
      nextToken?: string | null;
    } | null;
    settings?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    thumbS3Url?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    analyticsEnabled?: boolean | null;
    owner?: string | null;
    renders?: {
      __typename: "ModelServerRenderConnection";
      nextToken?: string | null;
    } | null;
    notifications?: {
      __typename: "ModelNotificationConnection";
      nextToken?: string | null;
    } | null;
    aliasId: string;
    minisiteConfigs?: Array<{
      __typename: "MinisiteConfig";
      scenes?: Array<string> | null;
      title?: string | null;
      description?: string | null;
      thumbUrl?: string | null;
      faviconUrl?: string | null;
      preCreate?: string | null;
    }> | null;
    playerVersionToUse?: string | null;
    customHtml?: string | null;
    dynamicThumbnails?: Array<{
      __typename: "DynamicThumbnail";
      name?: string | null;
      id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    publishedAt?: string | null;
    allowedOrigins?: Array<string | null> | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    textToVideoScript?: string | null;
    instantiatedFromUseCase?: string | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    isDeleted?: boolean | null;
    availableSceneLibraries?: {
      __typename: "ModelProjectSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    updatedAt: string;
  } | null;
};

export type CreateProjectVersionMutationVariables = {
  input: CreateProjectVersionInput;
  condition?: ModelProjectVersionConditionInput | null;
};

export type CreateProjectVersionMutation = {
  createProjectVersion?: {
    __typename: "ProjectVersion";
    id: string;
    accountOwner: string;
    owner?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    settings?: string | null;
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    updatedAt?: string | null;
    playerVersionToUse?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    textToVideoScript?: string | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    createdAt: string;
    projectProjectVersionsId?: string | null;
  } | null;
};

export type DeleteProjectVersionMutationVariables = {
  input: DeleteProjectVersionInput;
  condition?: ModelProjectVersionConditionInput | null;
};

export type DeleteProjectVersionMutation = {
  deleteProjectVersion?: {
    __typename: "ProjectVersion";
    id: string;
    accountOwner: string;
    owner?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    settings?: string | null;
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    updatedAt?: string | null;
    playerVersionToUse?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    textToVideoScript?: string | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    createdAt: string;
    projectProjectVersionsId?: string | null;
  } | null;
};

export type CreateSceneLibraryMutationVariables = {
  input: CreateSceneLibraryInput;
  condition?: ModelSceneLibraryConditionInput | null;
};

export type CreateSceneLibraryMutation = {
  createSceneLibrary?: {
    __typename: "SceneLibrary";
    id: string;
    title: string;
    vibe?: string | null;
    projectId: string;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    description?: string | null;
    thumbnail?: string | null;
    accounts?: {
      __typename: "ModelAccountSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    useCases?: {
      __typename: "ModelUseCaseSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    projects?: {
      __typename: "ModelProjectSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateSceneLibraryMutationVariables = {
  input: UpdateSceneLibraryInput;
  condition?: ModelSceneLibraryConditionInput | null;
};

export type UpdateSceneLibraryMutation = {
  updateSceneLibrary?: {
    __typename: "SceneLibrary";
    id: string;
    title: string;
    vibe?: string | null;
    projectId: string;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    description?: string | null;
    thumbnail?: string | null;
    accounts?: {
      __typename: "ModelAccountSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    useCases?: {
      __typename: "ModelUseCaseSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    projects?: {
      __typename: "ModelProjectSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteSceneLibraryMutationVariables = {
  input: DeleteSceneLibraryInput;
  condition?: ModelSceneLibraryConditionInput | null;
};

export type DeleteSceneLibraryMutation = {
  deleteSceneLibrary?: {
    __typename: "SceneLibrary";
    id: string;
    title: string;
    vibe?: string | null;
    projectId: string;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    description?: string | null;
    thumbnail?: string | null;
    accounts?: {
      __typename: "ModelAccountSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    useCases?: {
      __typename: "ModelUseCaseSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    projects?: {
      __typename: "ModelProjectSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateServerRenderMutationVariables = {
  input: CreateServerRenderInput;
  condition?: ModelServerRenderConditionInput | null;
};

export type CreateServerRenderMutation = {
  createServerRender?: {
    __typename: "ServerRender";
    id: string;
    projectId: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    scenes: Array<string>;
    data?: string | null;
    env?: string | null;
    outputFileName?: string | null;
    quality?: number | null;
    frameToStart?: number | null;
    frameToEnd?: number | null;
    format?: string | null;
    status?: {
      __typename: "ProjectStatus";
      ready?: string | null;
      status?: string | null;
      downloadLink?: string | null;
      code?: string | null;
    } | null;
    cognitoUserIdentifier?: string | null;
    cognitoGroupOwner?: string | null;
    createdAt?: string | null;
    updatedAt: string;
  } | null;
};

export type UpdateServerRenderMutationVariables = {
  input: UpdateServerRenderInput;
  condition?: ModelServerRenderConditionInput | null;
};

export type UpdateServerRenderMutation = {
  updateServerRender?: {
    __typename: "ServerRender";
    id: string;
    projectId: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    scenes: Array<string>;
    data?: string | null;
    env?: string | null;
    outputFileName?: string | null;
    quality?: number | null;
    frameToStart?: number | null;
    frameToEnd?: number | null;
    format?: string | null;
    status?: {
      __typename: "ProjectStatus";
      ready?: string | null;
      status?: string | null;
      downloadLink?: string | null;
      code?: string | null;
    } | null;
    cognitoUserIdentifier?: string | null;
    cognitoGroupOwner?: string | null;
    createdAt?: string | null;
    updatedAt: string;
  } | null;
};

export type DeleteServerRenderMutationVariables = {
  input: DeleteServerRenderInput;
  condition?: ModelServerRenderConditionInput | null;
};

export type DeleteServerRenderMutation = {
  deleteServerRender?: {
    __typename: "ServerRender";
    id: string;
    projectId: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    scenes: Array<string>;
    data?: string | null;
    env?: string | null;
    outputFileName?: string | null;
    quality?: number | null;
    frameToStart?: number | null;
    frameToEnd?: number | null;
    format?: string | null;
    status?: {
      __typename: "ProjectStatus";
      ready?: string | null;
      status?: string | null;
      downloadLink?: string | null;
      code?: string | null;
    } | null;
    cognitoUserIdentifier?: string | null;
    cognitoGroupOwner?: string | null;
    createdAt?: string | null;
    updatedAt: string;
  } | null;
};

export type CreateUseCaseMutationVariables = {
  input: CreateUseCaseInput;
  condition?: ModelUseCaseConditionInput | null;
};

export type CreateUseCaseMutation = {
  createUseCase?: {
    __typename: "UseCase";
    id: string;
    name: string;
    projectId: string;
    images?: Array<string> | null;
    shortDescription?: string | null;
    longDescription?: string | null;
    thumbnail?: string | null;
    demoLink?: string | null;
    videoPreview?: string | null;
    lineupId?: string | null;
    lineupsIds?: Array<string> | null;
    scenes?: Array<string> | null;
    liveControl?: string | null;
    liveControlSchema?: string | null;
    dynamicDataSchema?: string | null;
    categoryId?: string | null;
    category?: {
      __typename: "UseCaseCategory";
      id: string;
      name: string;
      description: string;
      thumbnail: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    availableSceneLibraries?: {
      __typename: "ModelUseCaseSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateUseCaseMutationVariables = {
  input: UpdateUseCaseInput;
  condition?: ModelUseCaseConditionInput | null;
};

export type UpdateUseCaseMutation = {
  updateUseCase?: {
    __typename: "UseCase";
    id: string;
    name: string;
    projectId: string;
    images?: Array<string> | null;
    shortDescription?: string | null;
    longDescription?: string | null;
    thumbnail?: string | null;
    demoLink?: string | null;
    videoPreview?: string | null;
    lineupId?: string | null;
    lineupsIds?: Array<string> | null;
    scenes?: Array<string> | null;
    liveControl?: string | null;
    liveControlSchema?: string | null;
    dynamicDataSchema?: string | null;
    categoryId?: string | null;
    category?: {
      __typename: "UseCaseCategory";
      id: string;
      name: string;
      description: string;
      thumbnail: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    availableSceneLibraries?: {
      __typename: "ModelUseCaseSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteUseCaseMutationVariables = {
  input: DeleteUseCaseInput;
  condition?: ModelUseCaseConditionInput | null;
};

export type DeleteUseCaseMutation = {
  deleteUseCase?: {
    __typename: "UseCase";
    id: string;
    name: string;
    projectId: string;
    images?: Array<string> | null;
    shortDescription?: string | null;
    longDescription?: string | null;
    thumbnail?: string | null;
    demoLink?: string | null;
    videoPreview?: string | null;
    lineupId?: string | null;
    lineupsIds?: Array<string> | null;
    scenes?: Array<string> | null;
    liveControl?: string | null;
    liveControlSchema?: string | null;
    dynamicDataSchema?: string | null;
    categoryId?: string | null;
    category?: {
      __typename: "UseCaseCategory";
      id: string;
      name: string;
      description: string;
      thumbnail: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    availableSceneLibraries?: {
      __typename: "ModelUseCaseSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateUseCaseTagMutationVariables = {
  input: CreateUseCaseTagInput;
  condition?: ModelUseCaseTagConditionInput | null;
};

export type CreateUseCaseTagMutation = {
  createUseCaseTag?: {
    __typename: "UseCaseTag";
    tag: string;
    useCaseIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateUseCaseTagMutationVariables = {
  input: UpdateUseCaseTagInput;
  condition?: ModelUseCaseTagConditionInput | null;
};

export type UpdateUseCaseTagMutation = {
  updateUseCaseTag?: {
    __typename: "UseCaseTag";
    tag: string;
    useCaseIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteUseCaseTagMutationVariables = {
  input: DeleteUseCaseTagInput;
  condition?: ModelUseCaseTagConditionInput | null;
};

export type DeleteUseCaseTagMutation = {
  deleteUseCaseTag?: {
    __typename: "UseCaseTag";
    tag: string;
    useCaseIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateUseCaseCategoryMutationVariables = {
  input: CreateUseCaseCategoryInput;
  condition?: ModelUseCaseCategoryConditionInput | null;
};

export type CreateUseCaseCategoryMutation = {
  createUseCaseCategory?: {
    __typename: "UseCaseCategory";
    id: string;
    name: string;
    description: string;
    thumbnail: string;
    useCases?: {
      __typename: "ModelUseCaseConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateUseCaseCategoryMutationVariables = {
  input: UpdateUseCaseCategoryInput;
  condition?: ModelUseCaseCategoryConditionInput | null;
};

export type UpdateUseCaseCategoryMutation = {
  updateUseCaseCategory?: {
    __typename: "UseCaseCategory";
    id: string;
    name: string;
    description: string;
    thumbnail: string;
    useCases?: {
      __typename: "ModelUseCaseConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteUseCaseCategoryMutationVariables = {
  input: DeleteUseCaseCategoryInput;
  condition?: ModelUseCaseCategoryConditionInput | null;
};

export type DeleteUseCaseCategoryMutation = {
  deleteUseCaseCategory?: {
    __typename: "UseCaseCategory";
    id: string;
    name: string;
    description: string;
    thumbnail: string;
    useCases?: {
      __typename: "ModelUseCaseConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateUserMutationVariables = {
  input: CreateUserInput;
  condition?: ModelUserConditionInput | null;
};

export type CreateUserMutation = {
  createUser?: {
    __typename: "User";
    id: string;
    email?: string | null;
    name?: string | null;
    lastName?: string | null;
    picture?: string | null;
    accounts?: {
      __typename: "ModelAccountUserConnection";
      nextToken?: string | null;
    } | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput;
  condition?: ModelUserConditionInput | null;
};

export type UpdateUserMutation = {
  updateUser?: {
    __typename: "User";
    id: string;
    email?: string | null;
    name?: string | null;
    lastName?: string | null;
    picture?: string | null;
    accounts?: {
      __typename: "ModelAccountUserConnection";
      nextToken?: string | null;
    } | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput;
  condition?: ModelUserConditionInput | null;
};

export type DeleteUserMutation = {
  deleteUser?: {
    __typename: "User";
    id: string;
    email?: string | null;
    name?: string | null;
    lastName?: string | null;
    picture?: string | null;
    accounts?: {
      __typename: "ModelAccountUserConnection";
      nextToken?: string | null;
    } | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type CreateAccountSceneLibrariesMutationVariables = {
  input: CreateAccountSceneLibrariesInput;
  condition?: ModelAccountSceneLibrariesConditionInput | null;
};

export type CreateAccountSceneLibrariesMutation = {
  createAccountSceneLibraries?: {
    __typename: "AccountSceneLibraries";
    id: string;
    accountID: string;
    sceneLibraryID: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateAccountSceneLibrariesMutationVariables = {
  input: UpdateAccountSceneLibrariesInput;
  condition?: ModelAccountSceneLibrariesConditionInput | null;
};

export type UpdateAccountSceneLibrariesMutation = {
  updateAccountSceneLibraries?: {
    __typename: "AccountSceneLibraries";
    id: string;
    accountID: string;
    sceneLibraryID: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteAccountSceneLibrariesMutationVariables = {
  input: DeleteAccountSceneLibrariesInput;
  condition?: ModelAccountSceneLibrariesConditionInput | null;
};

export type DeleteAccountSceneLibrariesMutation = {
  deleteAccountSceneLibraries?: {
    __typename: "AccountSceneLibraries";
    id: string;
    accountID: string;
    sceneLibraryID: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateProjectSceneLibrariesMutationVariables = {
  input: CreateProjectSceneLibrariesInput;
  condition?: ModelProjectSceneLibrariesConditionInput | null;
};

export type CreateProjectSceneLibrariesMutation = {
  createProjectSceneLibraries?: {
    __typename: "ProjectSceneLibraries";
    id: string;
    projectID: string;
    sceneLibraryID: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateProjectSceneLibrariesMutationVariables = {
  input: UpdateProjectSceneLibrariesInput;
  condition?: ModelProjectSceneLibrariesConditionInput | null;
};

export type UpdateProjectSceneLibrariesMutation = {
  updateProjectSceneLibraries?: {
    __typename: "ProjectSceneLibraries";
    id: string;
    projectID: string;
    sceneLibraryID: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteProjectSceneLibrariesMutationVariables = {
  input: DeleteProjectSceneLibrariesInput;
  condition?: ModelProjectSceneLibrariesConditionInput | null;
};

export type DeleteProjectSceneLibrariesMutation = {
  deleteProjectSceneLibraries?: {
    __typename: "ProjectSceneLibraries";
    id: string;
    projectID: string;
    sceneLibraryID: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateUseCaseSceneLibrariesMutationVariables = {
  input: CreateUseCaseSceneLibrariesInput;
  condition?: ModelUseCaseSceneLibrariesConditionInput | null;
};

export type CreateUseCaseSceneLibrariesMutation = {
  createUseCaseSceneLibraries?: {
    __typename: "UseCaseSceneLibraries";
    id: string;
    sceneLibraryID: string;
    useCaseID: string;
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    useCase: {
      __typename: "UseCase";
      id: string;
      name: string;
      projectId: string;
      images?: Array<string> | null;
      shortDescription?: string | null;
      longDescription?: string | null;
      thumbnail?: string | null;
      demoLink?: string | null;
      videoPreview?: string | null;
      lineupId?: string | null;
      lineupsIds?: Array<string> | null;
      scenes?: Array<string> | null;
      liveControl?: string | null;
      liveControlSchema?: string | null;
      dynamicDataSchema?: string | null;
      categoryId?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateUseCaseSceneLibrariesMutationVariables = {
  input: UpdateUseCaseSceneLibrariesInput;
  condition?: ModelUseCaseSceneLibrariesConditionInput | null;
};

export type UpdateUseCaseSceneLibrariesMutation = {
  updateUseCaseSceneLibraries?: {
    __typename: "UseCaseSceneLibraries";
    id: string;
    sceneLibraryID: string;
    useCaseID: string;
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    useCase: {
      __typename: "UseCase";
      id: string;
      name: string;
      projectId: string;
      images?: Array<string> | null;
      shortDescription?: string | null;
      longDescription?: string | null;
      thumbnail?: string | null;
      demoLink?: string | null;
      videoPreview?: string | null;
      lineupId?: string | null;
      lineupsIds?: Array<string> | null;
      scenes?: Array<string> | null;
      liveControl?: string | null;
      liveControlSchema?: string | null;
      dynamicDataSchema?: string | null;
      categoryId?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteUseCaseSceneLibrariesMutationVariables = {
  input: DeleteUseCaseSceneLibrariesInput;
  condition?: ModelUseCaseSceneLibrariesConditionInput | null;
};

export type DeleteUseCaseSceneLibrariesMutation = {
  deleteUseCaseSceneLibraries?: {
    __typename: "UseCaseSceneLibraries";
    id: string;
    sceneLibraryID: string;
    useCaseID: string;
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    useCase: {
      __typename: "UseCase";
      id: string;
      name: string;
      projectId: string;
      images?: Array<string> | null;
      shortDescription?: string | null;
      longDescription?: string | null;
      thumbnail?: string | null;
      demoLink?: string | null;
      videoPreview?: string | null;
      lineupId?: string | null;
      lineupsIds?: Array<string> | null;
      scenes?: Array<string> | null;
      liveControl?: string | null;
      liveControlSchema?: string | null;
      dynamicDataSchema?: string | null;
      categoryId?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateProjectMutationVariables = {
  input: CreateProjectInput;
};

export type CreateProjectMutation = {
  createProject?: {
    __typename: "Project";
    id: string;
    projectAccountId: string;
    title: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    allowCreateDataPoint?: boolean | null;
    allowDataConnect?: boolean | null;
    allowCrmConnect?: boolean | null;
    allowSdkConnect?: boolean | null;
    allowSendFormData?: boolean | null;
    analyticsReportUrl?: string | null;
    createdAt?: string | null;
    dataFiles?: Array<{
      __typename: "DataFile";
      fileName?: string | null;
      tag?: string | null;
      createdAt?: string | null;
    } | null> | null;
    description?: string | null;
    fileName?: string | null;
    jsonChanges?: string | null;
    jsonVidUrl?: string | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    projectVersions?: {
      __typename: "ModelProjectVersionConnection";
      nextToken?: string | null;
    } | null;
    formData?: {
      __typename: "ModelFormDataConnection";
      nextToken?: string | null;
    } | null;
    settings?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    thumbS3Url?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    analyticsEnabled?: boolean | null;
    owner?: string | null;
    renders?: {
      __typename: "ModelServerRenderConnection";
      nextToken?: string | null;
    } | null;
    notifications?: {
      __typename: "ModelNotificationConnection";
      nextToken?: string | null;
    } | null;
    aliasId: string;
    minisiteConfigs?: Array<{
      __typename: "MinisiteConfig";
      scenes?: Array<string> | null;
      title?: string | null;
      description?: string | null;
      thumbUrl?: string | null;
      faviconUrl?: string | null;
      preCreate?: string | null;
    }> | null;
    playerVersionToUse?: string | null;
    customHtml?: string | null;
    dynamicThumbnails?: Array<{
      __typename: "DynamicThumbnail";
      name?: string | null;
      id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    publishedAt?: string | null;
    allowedOrigins?: Array<string | null> | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    textToVideoScript?: string | null;
    instantiatedFromUseCase?: string | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    isDeleted?: boolean | null;
    availableSceneLibraries?: {
      __typename: "ModelProjectSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    updatedAt: string;
  } | null;
};

export type UpdateProjectMutationVariables = {
  input: UpdateProjectInput;
};

export type UpdateProjectMutation = {
  updateProject?: {
    __typename: "Project";
    id: string;
    projectAccountId: string;
    title: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    allowCreateDataPoint?: boolean | null;
    allowDataConnect?: boolean | null;
    allowCrmConnect?: boolean | null;
    allowSdkConnect?: boolean | null;
    allowSendFormData?: boolean | null;
    analyticsReportUrl?: string | null;
    createdAt?: string | null;
    dataFiles?: Array<{
      __typename: "DataFile";
      fileName?: string | null;
      tag?: string | null;
      createdAt?: string | null;
    } | null> | null;
    description?: string | null;
    fileName?: string | null;
    jsonChanges?: string | null;
    jsonVidUrl?: string | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    projectVersions?: {
      __typename: "ModelProjectVersionConnection";
      nextToken?: string | null;
    } | null;
    formData?: {
      __typename: "ModelFormDataConnection";
      nextToken?: string | null;
    } | null;
    settings?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    thumbS3Url?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    analyticsEnabled?: boolean | null;
    owner?: string | null;
    renders?: {
      __typename: "ModelServerRenderConnection";
      nextToken?: string | null;
    } | null;
    notifications?: {
      __typename: "ModelNotificationConnection";
      nextToken?: string | null;
    } | null;
    aliasId: string;
    minisiteConfigs?: Array<{
      __typename: "MinisiteConfig";
      scenes?: Array<string> | null;
      title?: string | null;
      description?: string | null;
      thumbUrl?: string | null;
      faviconUrl?: string | null;
      preCreate?: string | null;
    }> | null;
    playerVersionToUse?: string | null;
    customHtml?: string | null;
    dynamicThumbnails?: Array<{
      __typename: "DynamicThumbnail";
      name?: string | null;
      id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    publishedAt?: string | null;
    allowedOrigins?: Array<string | null> | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    textToVideoScript?: string | null;
    instantiatedFromUseCase?: string | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    isDeleted?: boolean | null;
    availableSceneLibraries?: {
      __typename: "ModelProjectSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    updatedAt: string;
  } | null;
};

export type UpdateProjectVersionMutationVariables = {
  input: UpdateProjectVersionInput;
};

export type UpdateProjectVersionMutation = {
  updateProjectVersion?: {
    __typename: "ProjectVersion";
    id: string;
    accountOwner: string;
    owner?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    settings?: string | null;
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    updatedAt?: string | null;
    playerVersionToUse?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    textToVideoScript?: string | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    createdAt: string;
    projectProjectVersionsId?: string | null;
  } | null;
};

export type SendInstantNotificationMutationVariables = {
  input?: SendInstantNotificationInput | null;
};

export type SendInstantNotificationMutation = {
  sendInstantNotification?: {
    __typename: "InstantNotification";
    type: string;
    subType?: string | null;
    status: NotificationStatus;
    title: string;
    message: string;
    owner: string;
    projectId?: string | null;
    extra?: string | null;
  } | null;
};

export type ByAccountQueryVariables = {
  input: ByAccountInput;
};

export type ByAccountQuery = {
  byAccount?: {
    __typename: "ByAccountOutput";
    items: Array<{
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetAccountQueryVariables = {
  id: string;
};

export type GetAccountQuery = {
  getAccount?: {
    __typename: "Account";
    id: string;
    gid: string;
    name: string;
    projects?: {
      __typename: "ModelProjectConnection";
      nextToken?: string | null;
    } | null;
    fileuploads?: Array<{
      __typename: "FileUpload";
      originalName?: string | null;
      createdAt: string;
      fileName: string;
      fileStatus?: string | null;
      fileError?: string | null;
      numRecords?: number | null;
      numErrors?: number | null;
      totalRecords?: number | null;
      writtenRecords?: number | null;
    }> | null;
    integrations?: {
      __typename: "Integrations";
      hubspot?: string | null;
    } | null;
    aliasId: string;
    fonts?: Array<{
      __typename: "AccountFont";
      fontFamily: string;
    }> | null;
    minisiteDomain?: string | null;
    mfaEnabled?: boolean | null;
    ownerId?: string | null;
    users?: {
      __typename: "ModelAccountUserConnection";
      nextToken?: string | null;
    } | null;
    accountUsageType?: string | null;
    companySize?: string | null;
    tierId: string;
    tier?: {
      __typename: "Tier";
      id: string;
      name: string;
      monthlyPrice: string;
      annualPrice: string;
      description: string;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
    stripeCustomerId?: string | null;
    featureOverrides?: {
      __typename: "ModelAccountFeatureOverrideConnection";
      nextToken?: string | null;
    } | null;
    createNewVideosWithBlingLogo?: boolean | null;
    accountType?: {
      __typename: "AccountType";
      levelName: AccountTypeName;
    } | null;
    currentBillingPeriod?: {
      __typename: "BillingPeriod";
      startDate: string;
      endDate: string;
    } | null;
    ppvCurrentBillingPeriod?: {
      __typename: "BillingPeriod";
      startDate: string;
      endDate: string;
    } | null;
    availableSceneLibraries?: {
      __typename: "ModelAccountSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListAccountsQueryVariables = {
  filter?: ModelAccountFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListAccountsQuery = {
  listAccounts?: {
    __typename: "ModelAccountConnection";
    items: Array<{
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetAccountUserQueryVariables = {
  id: string;
};

export type GetAccountUserQuery = {
  getAccountUser?: {
    __typename: "AccountUser";
    id: string;
    email: string;
    account?: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    accountId: string;
    user?: {
      __typename: "User";
      id: string;
      email?: string | null;
      name?: string | null;
      lastName?: string | null;
      picture?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    userId: string;
    createdAt: string;
    updatedAt: string;
    workType?: string | null;
    roleInCompany?: string | null;
    permissions?: Array<string | null> | null;
  } | null;
};

export type ListUsersThatWorkOnAccountQueryVariables = {
  accountId: string;
  userId?: ModelIDKeyConditionInput | null;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelAccountUserFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListUsersThatWorkOnAccountQuery = {
  listUsersThatWorkOnAccount?: {
    __typename: "ModelAccountUserConnection";
    items: Array<{
      __typename: "AccountUser";
      id: string;
      email: string;
      accountId: string;
      userId: string;
      createdAt: string;
      updatedAt: string;
      workType?: string | null;
      roleInCompany?: string | null;
      permissions?: Array<string | null> | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ListAccountsForUserQueryVariables = {
  userId: string;
  accountId?: ModelIDKeyConditionInput | null;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelAccountUserFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListAccountsForUserQuery = {
  listAccountsForUser?: {
    __typename: "ModelAccountUserConnection";
    items: Array<{
      __typename: "AccountUser";
      id: string;
      email: string;
      accountId: string;
      userId: string;
      createdAt: string;
      updatedAt: string;
      workType?: string | null;
      roleInCompany?: string | null;
      permissions?: Array<string | null> | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetInviteQueryVariables = {
  id: string;
};

export type GetInviteQuery = {
  getInvite?: {
    __typename: "Invite";
    id: string;
    senderId: string;
    email: string;
    accountId: string;
    account?: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    confirmCode: string;
    confirmed: boolean;
    createdAt: string;
    updatedAt: string;
    permissions?: Array<string | null> | null;
  } | null;
};

export type ListInvitesQueryVariables = {
  id?: string | null;
  filter?: ModelInviteFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
  sortDirection?: ModelSortDirection | null;
};

export type ListInvitesQuery = {
  listInvites?: {
    __typename: "ModelInviteConnection";
    items: Array<{
      __typename: "Invite";
      id: string;
      senderId: string;
      email: string;
      accountId: string;
      confirmCode: string;
      confirmed: boolean;
      createdAt: string;
      updatedAt: string;
      permissions?: Array<string | null> | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ListInvitesBySenderQueryVariables = {
  senderId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelInviteFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListInvitesBySenderQuery = {
  listInvitesBySender?: {
    __typename: "ModelInviteConnection";
    items: Array<{
      __typename: "Invite";
      id: string;
      senderId: string;
      email: string;
      accountId: string;
      confirmCode: string;
      confirmed: boolean;
      createdAt: string;
      updatedAt: string;
      permissions?: Array<string | null> | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ListInvitesByAccountQueryVariables = {
  accountId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelInviteFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListInvitesByAccountQuery = {
  listInvitesByAccount?: {
    __typename: "ModelInviteConnection";
    items: Array<{
      __typename: "Invite";
      id: string;
      senderId: string;
      email: string;
      accountId: string;
      confirmCode: string;
      confirmed: boolean;
      createdAt: string;
      updatedAt: string;
      permissions?: Array<string | null> | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetTierQueryVariables = {
  id: string;
};

export type GetTierQuery = {
  getTier?: {
    __typename: "Tier";
    id: string;
    name: string;
    monthlyPrice: string;
    annualPrice: string;
    description: string;
    enabled: boolean;
    features?: {
      __typename: "ModelTierFeatureConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListTiersQueryVariables = {
  filter?: ModelTierFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListTiersQuery = {
  listTiers?: {
    __typename: "ModelTierConnection";
    items: Array<{
      __typename: "Tier";
      id: string;
      name: string;
      monthlyPrice: string;
      annualPrice: string;
      description: string;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetFeatureQueryVariables = {
  id: string;
};

export type GetFeatureQuery = {
  getFeature?: {
    __typename: "Feature";
    id: string;
    name: string;
    description?: string | null;
    enabled: boolean;
    tierFeatures?: {
      __typename: "ModelTierFeatureConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListFeaturesQueryVariables = {
  filter?: ModelFeatureFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListFeaturesQuery = {
  listFeatures?: {
    __typename: "ModelFeatureConnection";
    items: Array<{
      __typename: "Feature";
      id: string;
      name: string;
      description?: string | null;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetTierFeatureQueryVariables = {
  id: string;
};

export type GetTierFeatureQuery = {
  getTierFeature?: {
    __typename: "TierFeature";
    id: string;
    tier: {
      __typename: "Tier";
      id: string;
      name: string;
      monthlyPrice: string;
      annualPrice: string;
      description: string;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    };
    tierId: string;
    feature: {
      __typename: "Feature";
      id: string;
      name: string;
      description?: string | null;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    };
    featureId: string;
    description?: string | null;
    limitValue?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListTierFeaturesQueryVariables = {
  filter?: ModelTierFeatureFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListTierFeaturesQuery = {
  listTierFeatures?: {
    __typename: "ModelTierFeatureConnection";
    items: Array<{
      __typename: "TierFeature";
      id: string;
      tierId: string;
      featureId: string;
      description?: string | null;
      limitValue?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetAccountFeatureOverrideQueryVariables = {
  id: string;
};

export type GetAccountFeatureOverrideQuery = {
  getAccountFeatureOverride?: {
    __typename: "AccountFeatureOverride";
    id: string;
    accountId: string;
    featureId: string;
    reason?: string | null;
    limitValue?: number | null;
    enabled: boolean;
    expiresAt?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListAccountFeatureOverridesQueryVariables = {
  filter?: ModelAccountFeatureOverrideFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListAccountFeatureOverridesQuery = {
  listAccountFeatureOverrides?: {
    __typename: "ModelAccountFeatureOverrideConnection";
    items: Array<{
      __typename: "AccountFeatureOverride";
      id: string;
      accountId: string;
      featureId: string;
      reason?: string | null;
      limitValue?: number | null;
      enabled: boolean;
      expiresAt?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetFormDataQueryVariables = {
  id: string;
};

export type GetFormDataQuery = {
  getFormData?: {
    __typename: "FormData";
    id: string;
    accountOwner: string;
    projectFormDataId: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    data: string;
    sessionId: string;
    userId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListFormDataQueryVariables = {
  filter?: ModelFormDataFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListFormDataQuery = {
  listFormData?: {
    __typename: "ModelFormDataConnection";
    items: Array<{
      __typename: "FormData";
      id: string;
      accountOwner: string;
      projectFormDataId: string;
      data: string;
      sessionId: string;
      userId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type FormDataByDateQueryVariables = {
  projectFormDataId: string;
  createdAt?: ModelStringKeyConditionInput | null;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelFormDataFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type FormDataByDateQuery = {
  formDataByDate?: {
    __typename: "ModelFormDataConnection";
    items: Array<{
      __typename: "FormData";
      id: string;
      accountOwner: string;
      projectFormDataId: string;
      data: string;
      sessionId: string;
      userId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetNotificationQueryVariables = {
  id: string;
};

export type GetNotificationQuery = {
  getNotification?: {
    __typename: "Notification";
    id: string;
    type: string;
    subType?: string | null;
    status: NotificationStatus;
    title: string;
    message: string;
    read: boolean;
    owner: string;
    projectId?: string | null;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    createdAt: string;
    extra?: string | null;
    updatedAt: string;
    projectNotificationsId?: string | null;
  } | null;
};

export type ListNotificationsQueryVariables = {
  filter?: ModelNotificationFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListNotificationsQuery = {
  listNotifications?: {
    __typename: "ModelNotificationConnection";
    items: Array<{
      __typename: "Notification";
      id: string;
      type: string;
      subType?: string | null;
      status: NotificationStatus;
      title: string;
      message: string;
      read: boolean;
      owner: string;
      projectId?: string | null;
      createdAt: string;
      extra?: string | null;
      updatedAt: string;
      projectNotificationsId?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ListNotificationByTypeQueryVariables = {
  type: string;
  createdAt?: ModelStringKeyConditionInput | null;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelNotificationFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListNotificationByTypeQuery = {
  listNotificationByType?: {
    __typename: "ModelNotificationConnection";
    items: Array<{
      __typename: "Notification";
      id: string;
      type: string;
      subType?: string | null;
      status: NotificationStatus;
      title: string;
      message: string;
      read: boolean;
      owner: string;
      projectId?: string | null;
      createdAt: string;
      extra?: string | null;
      updatedAt: string;
      projectNotificationsId?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ListNotificationByOwnerQueryVariables = {
  owner: string;
  createdAt?: ModelStringKeyConditionInput | null;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelNotificationFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListNotificationByOwnerQuery = {
  listNotificationByOwner?: {
    __typename: "ModelNotificationConnection";
    items: Array<{
      __typename: "Notification";
      id: string;
      type: string;
      subType?: string | null;
      status: NotificationStatus;
      title: string;
      message: string;
      read: boolean;
      owner: string;
      projectId?: string | null;
      createdAt: string;
      extra?: string | null;
      updatedAt: string;
      projectNotificationsId?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetProjectQueryVariables = {
  id: string;
};

export type GetProjectQuery = {
  getProject?: {
    __typename: "Project";
    id: string;
    projectAccountId: string;
    title: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    allowCreateDataPoint?: boolean | null;
    allowDataConnect?: boolean | null;
    allowCrmConnect?: boolean | null;
    allowSdkConnect?: boolean | null;
    allowSendFormData?: boolean | null;
    analyticsReportUrl?: string | null;
    createdAt?: string | null;
    dataFiles?: Array<{
      __typename: "DataFile";
      fileName?: string | null;
      tag?: string | null;
      createdAt?: string | null;
    } | null> | null;
    description?: string | null;
    fileName?: string | null;
    jsonChanges?: string | null;
    jsonVidUrl?: string | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    projectVersions?: {
      __typename: "ModelProjectVersionConnection";
      nextToken?: string | null;
    } | null;
    formData?: {
      __typename: "ModelFormDataConnection";
      nextToken?: string | null;
    } | null;
    settings?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    thumbS3Url?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    analyticsEnabled?: boolean | null;
    owner?: string | null;
    renders?: {
      __typename: "ModelServerRenderConnection";
      nextToken?: string | null;
    } | null;
    notifications?: {
      __typename: "ModelNotificationConnection";
      nextToken?: string | null;
    } | null;
    aliasId: string;
    minisiteConfigs?: Array<{
      __typename: "MinisiteConfig";
      scenes?: Array<string> | null;
      title?: string | null;
      description?: string | null;
      thumbUrl?: string | null;
      faviconUrl?: string | null;
      preCreate?: string | null;
    }> | null;
    playerVersionToUse?: string | null;
    customHtml?: string | null;
    dynamicThumbnails?: Array<{
      __typename: "DynamicThumbnail";
      name?: string | null;
      id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    publishedAt?: string | null;
    allowedOrigins?: Array<string | null> | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    textToVideoScript?: string | null;
    instantiatedFromUseCase?: string | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    isDeleted?: boolean | null;
    availableSceneLibraries?: {
      __typename: "ModelProjectSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    updatedAt: string;
  } | null;
};

export type ListProjectsQueryVariables = {
  filter?: ModelProjectFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListProjectsQuery = {
  listProjects?: {
    __typename: "ModelProjectConnection";
    items: Array<{
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ListProjectsByAccountQueryVariables = {
  projectAccountId: string;
  createdAt?: ModelStringKeyConditionInput | null;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelProjectFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListProjectsByAccountQuery = {
  listProjectsByAccount?: {
    __typename: "ModelProjectConnection";
    items: Array<{
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetProjectByAliasIdQueryVariables = {
  aliasId: string;
  projectAccountId?: ModelIDKeyConditionInput | null;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelProjectFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type GetProjectByAliasIdQuery = {
  getProjectByAliasId?: {
    __typename: "ModelProjectConnection";
    items: Array<{
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetProjectChangeActivityQueryVariables = {
  id: string;
};

export type GetProjectChangeActivityQuery = {
  getProjectChangeActivity?: {
    __typename: "ProjectChangeActivity";
    projectId: string;
    before?: {
      __typename: "ProjectDataChangeActivity";
      projectAccountId?: string | null;
      title?: string | null;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      type: string;
      owner?: string | null;
    } | null;
    after?: {
      __typename: "ProjectDataChangeActivity";
      projectAccountId?: string | null;
      title?: string | null;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      type: string;
      owner?: string | null;
    } | null;
    owner?: string | null;
    email?: string | null;
    origin?: string | null;
    accountOwner: string;
    createdAt: string;
    id: string;
    updatedAt: string;
  } | null;
};

export type ListProjectChangeActivitiesQueryVariables = {
  filter?: ModelProjectChangeActivityFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListProjectChangeActivitiesQuery = {
  listProjectChangeActivities?: {
    __typename: "ModelProjectChangeActivityConnection";
    items: Array<{
      __typename: "ProjectChangeActivity";
      projectId: string;
      owner?: string | null;
      email?: string | null;
      origin?: string | null;
      accountOwner: string;
      createdAt: string;
      id: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetProjectVersionChangeActivityQueryVariables = {
  id: string;
};

export type GetProjectVersionChangeActivityQuery = {
  getProjectVersionChangeActivity?: {
    __typename: "ProjectVersionChangeActivity";
    projectId: string;
    before?: {
      __typename: "ProjectDataChangeActivity";
      projectAccountId?: string | null;
      title?: string | null;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      type: string;
      owner?: string | null;
    } | null;
    after?: {
      __typename: "ProjectDataChangeActivity";
      projectAccountId?: string | null;
      title?: string | null;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      type: string;
      owner?: string | null;
    } | null;
    owner?: string | null;
    origin?: string | null;
    accountOwner: string;
    createdAt: string;
    id: string;
    updatedAt: string;
  } | null;
};

export type ListProjectVersionChangeActivitiesQueryVariables = {
  filter?: ModelProjectVersionChangeActivityFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListProjectVersionChangeActivitiesQuery = {
  listProjectVersionChangeActivities?: {
    __typename: "ModelProjectVersionChangeActivityConnection";
    items: Array<{
      __typename: "ProjectVersionChangeActivity";
      projectId: string;
      owner?: string | null;
      origin?: string | null;
      accountOwner: string;
      createdAt: string;
      id: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetProjectVersionQueryVariables = {
  id: string;
};

export type GetProjectVersionQuery = {
  getProjectVersion?: {
    __typename: "ProjectVersion";
    id: string;
    accountOwner: string;
    owner?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    settings?: string | null;
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    updatedAt?: string | null;
    playerVersionToUse?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    textToVideoScript?: string | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    createdAt: string;
    projectProjectVersionsId?: string | null;
  } | null;
};

export type ListProjectVersionsQueryVariables = {
  filter?: ModelProjectVersionFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListProjectVersionsQuery = {
  listProjectVersions?: {
    __typename: "ModelProjectVersionConnection";
    items: Array<{
      __typename: "ProjectVersion";
      id: string;
      accountOwner: string;
      owner?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      settings?: string | null;
      updatedAt?: string | null;
      playerVersionToUse?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      textToVideoScript?: string | null;
      createdAt: string;
      projectProjectVersionsId?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ListProjectVersionsByAccountQueryVariables = {
  accountOwner: string;
  updatedAt?: ModelStringKeyConditionInput | null;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelProjectVersionFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListProjectVersionsByAccountQuery = {
  listProjectVersionsByAccount?: {
    __typename: "ModelProjectVersionConnection";
    items: Array<{
      __typename: "ProjectVersion";
      id: string;
      accountOwner: string;
      owner?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      settings?: string | null;
      updatedAt?: string | null;
      playerVersionToUse?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      textToVideoScript?: string | null;
      createdAt: string;
      projectProjectVersionsId?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetSceneLibraryQueryVariables = {
  id: string;
};

export type GetSceneLibraryQuery = {
  getSceneLibrary?: {
    __typename: "SceneLibrary";
    id: string;
    title: string;
    vibe?: string | null;
    projectId: string;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    description?: string | null;
    thumbnail?: string | null;
    accounts?: {
      __typename: "ModelAccountSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    useCases?: {
      __typename: "ModelUseCaseSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    projects?: {
      __typename: "ModelProjectSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListSceneLibrariesQueryVariables = {
  filter?: ModelSceneLibraryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListSceneLibrariesQuery = {
  listSceneLibraries?: {
    __typename: "ModelSceneLibraryConnection";
    items: Array<{
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetServerRenderQueryVariables = {
  id: string;
};

export type GetServerRenderQuery = {
  getServerRender?: {
    __typename: "ServerRender";
    id: string;
    projectId: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    scenes: Array<string>;
    data?: string | null;
    env?: string | null;
    outputFileName?: string | null;
    quality?: number | null;
    frameToStart?: number | null;
    frameToEnd?: number | null;
    format?: string | null;
    status?: {
      __typename: "ProjectStatus";
      ready?: string | null;
      status?: string | null;
      downloadLink?: string | null;
      code?: string | null;
    } | null;
    cognitoUserIdentifier?: string | null;
    cognitoGroupOwner?: string | null;
    createdAt?: string | null;
    updatedAt: string;
  } | null;
};

export type ListServerRendersQueryVariables = {
  filter?: ModelServerRenderFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListServerRendersQuery = {
  listServerRenders?: {
    __typename: "ModelServerRenderConnection";
    items: Array<{
      __typename: "ServerRender";
      id: string;
      projectId: string;
      scenes: Array<string>;
      data?: string | null;
      env?: string | null;
      outputFileName?: string | null;
      quality?: number | null;
      frameToStart?: number | null;
      frameToEnd?: number | null;
      format?: string | null;
      cognitoUserIdentifier?: string | null;
      cognitoGroupOwner?: string | null;
      createdAt?: string | null;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetUseCaseQueryVariables = {
  id: string;
};

export type GetUseCaseQuery = {
  getUseCase?: {
    __typename: "UseCase";
    id: string;
    name: string;
    projectId: string;
    images?: Array<string> | null;
    shortDescription?: string | null;
    longDescription?: string | null;
    thumbnail?: string | null;
    demoLink?: string | null;
    videoPreview?: string | null;
    lineupId?: string | null;
    lineupsIds?: Array<string> | null;
    scenes?: Array<string> | null;
    liveControl?: string | null;
    liveControlSchema?: string | null;
    dynamicDataSchema?: string | null;
    categoryId?: string | null;
    category?: {
      __typename: "UseCaseCategory";
      id: string;
      name: string;
      description: string;
      thumbnail: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    availableSceneLibraries?: {
      __typename: "ModelUseCaseSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListUseCasesQueryVariables = {
  filter?: ModelUseCaseFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListUseCasesQuery = {
  listUseCases?: {
    __typename: "ModelUseCaseConnection";
    items: Array<{
      __typename: "UseCase";
      id: string;
      name: string;
      projectId: string;
      images?: Array<string> | null;
      shortDescription?: string | null;
      longDescription?: string | null;
      thumbnail?: string | null;
      demoLink?: string | null;
      videoPreview?: string | null;
      lineupId?: string | null;
      lineupsIds?: Array<string> | null;
      scenes?: Array<string> | null;
      liveControl?: string | null;
      liveControlSchema?: string | null;
      dynamicDataSchema?: string | null;
      categoryId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetUseCaseTagQueryVariables = {
  tag: string;
};

export type GetUseCaseTagQuery = {
  getUseCaseTag?: {
    __typename: "UseCaseTag";
    tag: string;
    useCaseIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListUseCaseTagsQueryVariables = {
  tag?: string | null;
  filter?: ModelUseCaseTagFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
  sortDirection?: ModelSortDirection | null;
};

export type ListUseCaseTagsQuery = {
  listUseCaseTags?: {
    __typename: "ModelUseCaseTagConnection";
    items: Array<{
      __typename: "UseCaseTag";
      tag: string;
      useCaseIds: Array<string>;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetUseCaseCategoryQueryVariables = {
  id: string;
};

export type GetUseCaseCategoryQuery = {
  getUseCaseCategory?: {
    __typename: "UseCaseCategory";
    id: string;
    name: string;
    description: string;
    thumbnail: string;
    useCases?: {
      __typename: "ModelUseCaseConnection";
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListUseCaseCategoriesQueryVariables = {
  id?: string | null;
  filter?: ModelUseCaseCategoryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
  sortDirection?: ModelSortDirection | null;
};

export type ListUseCaseCategoriesQuery = {
  listUseCaseCategories?: {
    __typename: "ModelUseCaseCategoryConnection";
    items: Array<{
      __typename: "UseCaseCategory";
      id: string;
      name: string;
      description: string;
      thumbnail: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetUserQueryVariables = {
  id: string;
};

export type GetUserQuery = {
  getUser?: {
    __typename: "User";
    id: string;
    email?: string | null;
    name?: string | null;
    lastName?: string | null;
    picture?: string | null;
    accounts?: {
      __typename: "ModelAccountUserConnection";
      nextToken?: string | null;
    } | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListUsersQuery = {
  listUsers?: {
    __typename: "ModelUserConnection";
    items: Array<{
      __typename: "User";
      id: string;
      email?: string | null;
      name?: string | null;
      lastName?: string | null;
      picture?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetAccountSceneLibrariesQueryVariables = {
  id: string;
};

export type GetAccountSceneLibrariesQuery = {
  getAccountSceneLibraries?: {
    __typename: "AccountSceneLibraries";
    id: string;
    accountID: string;
    sceneLibraryID: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListAccountSceneLibrariesQueryVariables = {
  filter?: ModelAccountSceneLibrariesFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListAccountSceneLibrariesQuery = {
  listAccountSceneLibraries?: {
    __typename: "ModelAccountSceneLibrariesConnection";
    items: Array<{
      __typename: "AccountSceneLibraries";
      id: string;
      accountID: string;
      sceneLibraryID: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetProjectSceneLibrariesQueryVariables = {
  id: string;
};

export type GetProjectSceneLibrariesQuery = {
  getProjectSceneLibraries?: {
    __typename: "ProjectSceneLibraries";
    id: string;
    projectID: string;
    sceneLibraryID: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListProjectSceneLibrariesQueryVariables = {
  filter?: ModelProjectSceneLibrariesFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListProjectSceneLibrariesQuery = {
  listProjectSceneLibraries?: {
    __typename: "ModelProjectSceneLibrariesConnection";
    items: Array<{
      __typename: "ProjectSceneLibraries";
      id: string;
      projectID: string;
      sceneLibraryID: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetUseCaseSceneLibrariesQueryVariables = {
  id: string;
};

export type GetUseCaseSceneLibrariesQuery = {
  getUseCaseSceneLibraries?: {
    __typename: "UseCaseSceneLibraries";
    id: string;
    sceneLibraryID: string;
    useCaseID: string;
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    useCase: {
      __typename: "UseCase";
      id: string;
      name: string;
      projectId: string;
      images?: Array<string> | null;
      shortDescription?: string | null;
      longDescription?: string | null;
      thumbnail?: string | null;
      demoLink?: string | null;
      videoPreview?: string | null;
      lineupId?: string | null;
      lineupsIds?: Array<string> | null;
      scenes?: Array<string> | null;
      liveControl?: string | null;
      liveControlSchema?: string | null;
      dynamicDataSchema?: string | null;
      categoryId?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListUseCaseSceneLibrariesQueryVariables = {
  filter?: ModelUseCaseSceneLibrariesFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListUseCaseSceneLibrariesQuery = {
  listUseCaseSceneLibraries?: {
    __typename: "ModelUseCaseSceneLibrariesConnection";
    items: Array<{
      __typename: "UseCaseSceneLibraries";
      id: string;
      sceneLibraryID: string;
      useCaseID: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type OnUpdateProjectSubSubscriptionVariables = {
  id?: string | null;
};

export type OnUpdateProjectSubSubscription = {
  onUpdateProjectSub?: {
    __typename: "Project";
    id: string;
    projectAccountId: string;
    title: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    allowCreateDataPoint?: boolean | null;
    allowDataConnect?: boolean | null;
    allowCrmConnect?: boolean | null;
    allowSdkConnect?: boolean | null;
    allowSendFormData?: boolean | null;
    analyticsReportUrl?: string | null;
    createdAt?: string | null;
    dataFiles?: Array<{
      __typename: "DataFile";
      fileName?: string | null;
      tag?: string | null;
      createdAt?: string | null;
    } | null> | null;
    description?: string | null;
    fileName?: string | null;
    jsonChanges?: string | null;
    jsonVidUrl?: string | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    projectVersions?: {
      __typename: "ModelProjectVersionConnection";
      nextToken?: string | null;
    } | null;
    formData?: {
      __typename: "ModelFormDataConnection";
      nextToken?: string | null;
    } | null;
    settings?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    thumbS3Url?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    analyticsEnabled?: boolean | null;
    owner?: string | null;
    renders?: {
      __typename: "ModelServerRenderConnection";
      nextToken?: string | null;
    } | null;
    notifications?: {
      __typename: "ModelNotificationConnection";
      nextToken?: string | null;
    } | null;
    aliasId: string;
    minisiteConfigs?: Array<{
      __typename: "MinisiteConfig";
      scenes?: Array<string> | null;
      title?: string | null;
      description?: string | null;
      thumbUrl?: string | null;
      faviconUrl?: string | null;
      preCreate?: string | null;
    }> | null;
    playerVersionToUse?: string | null;
    customHtml?: string | null;
    dynamicThumbnails?: Array<{
      __typename: "DynamicThumbnail";
      name?: string | null;
      id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    publishedAt?: string | null;
    allowedOrigins?: Array<string | null> | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    textToVideoScript?: string | null;
    instantiatedFromUseCase?: string | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    isDeleted?: boolean | null;
    availableSceneLibraries?: {
      __typename: "ModelProjectSceneLibrariesConnection";
      nextToken?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    updatedAt: string;
  } | null;
};

export type OnUpdateProjectVersionSubSubscriptionVariables = {
  id?: string | null;
};

export type OnUpdateProjectVersionSubSubscription = {
  onUpdateProjectVersionSub?: {
    __typename: "ProjectVersion";
    id: string;
    accountOwner: string;
    owner?: string | null;
    stateJsonSchemaStr?: string | null;
    settingsJsonSchemaStr?: string | null;
    settings?: string | null;
    videoParts?: Array<{
      __typename: "VidPart";
      name: string;
      jsonUrl: string;
      mods?: string | null;
      updatedAt?: string | null;
      hasVideo?: boolean | null;
      origin?: string | null;
      playerVersionToUse?: string | null;
      description?: string | null;
    }> | null;
    updatedAt?: string | null;
    playerVersionToUse?: string | null;
    experiments?: Array<{
      __typename: "Experiment";
      id: string;
      type: string;
    }> | null;
    experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
    textToVideoScript?: string | null;
    flowDiagram?: {
      __typename: "FlowDiagram";
    } | null;
    nodeLayout?: {
      __typename: "NodeLayoutMap";
    } | null;
    overlay?: {
      __typename: "Overlay";
    } | null;
    fontOverrides?: Array<{
      __typename: "Font";
      family: string;
      url: string;
      weight: string;
      style: string;
    }> | null;
    playerSettings?: {
      __typename: "PlayerSettings";
      autoplay?: boolean | null;
      autoplay_delay?: number | null;
      posterFrame?: number | null;
      showTimeline?: boolean | null;
      storiesMode?: boolean | null;
      color_loader?: string | null;
      color_ctrlBtns?: string | null;
      color_rail?: string | null;
      color_progress?: string | null;
      color_thumb?: string | null;
      color_bg?: string | null;
      muted?: boolean | null;
      autoReplay?: boolean | null;
      showBlingsLogo?: number | null;
      blingsLogoColor?: string | null;
      loadingText?: string | null;
      loadingImage?: string | null;
    } | null;
    fontMap?: Array<{
      __typename: "FontMap";
      slot: string;
    }> | null;
    createdAt: string;
    projectProjectVersionsId?: string | null;
  } | null;
};

export type OnSendInstantNotificationSubscriptionVariables = {
  owner: string;
};

export type OnSendInstantNotificationSubscription = {
  onSendInstantNotification?: {
    __typename: "InstantNotification";
    type: string;
    subType?: string | null;
    status: NotificationStatus;
    title: string;
    message: string;
    owner: string;
    projectId?: string | null;
    extra?: string | null;
  } | null;
};

export type OnCreateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null;
  owner?: string | null;
};

export type OnCreateNotificationSubscription = {
  onCreateNotification?: {
    __typename: "Notification";
    id: string;
    type: string;
    subType?: string | null;
    status: NotificationStatus;
    title: string;
    message: string;
    read: boolean;
    owner: string;
    projectId?: string | null;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    createdAt: string;
    extra?: string | null;
    updatedAt: string;
    projectNotificationsId?: string | null;
  } | null;
};

export type OnUpdateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null;
  owner?: string | null;
};

export type OnUpdateNotificationSubscription = {
  onUpdateNotification?: {
    __typename: "Notification";
    id: string;
    type: string;
    subType?: string | null;
    status: NotificationStatus;
    title: string;
    message: string;
    read: boolean;
    owner: string;
    projectId?: string | null;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    createdAt: string;
    extra?: string | null;
    updatedAt: string;
    projectNotificationsId?: string | null;
  } | null;
};

export type OnDeleteNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null;
  owner?: string | null;
};

export type OnDeleteNotificationSubscription = {
  onDeleteNotification?: {
    __typename: "Notification";
    id: string;
    type: string;
    subType?: string | null;
    status: NotificationStatus;
    title: string;
    message: string;
    read: boolean;
    owner: string;
    projectId?: string | null;
    project?: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    } | null;
    createdAt: string;
    extra?: string | null;
    updatedAt: string;
    projectNotificationsId?: string | null;
  } | null;
};

export type OnCreateAccountSceneLibrariesSubscriptionVariables = {
  filter?: ModelSubscriptionAccountSceneLibrariesFilterInput | null;
};

export type OnCreateAccountSceneLibrariesSubscription = {
  onCreateAccountSceneLibraries?: {
    __typename: "AccountSceneLibraries";
    id: string;
    accountID: string;
    sceneLibraryID: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateAccountSceneLibrariesSubscriptionVariables = {
  filter?: ModelSubscriptionAccountSceneLibrariesFilterInput | null;
};

export type OnUpdateAccountSceneLibrariesSubscription = {
  onUpdateAccountSceneLibraries?: {
    __typename: "AccountSceneLibraries";
    id: string;
    accountID: string;
    sceneLibraryID: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteAccountSceneLibrariesSubscriptionVariables = {
  filter?: ModelSubscriptionAccountSceneLibrariesFilterInput | null;
};

export type OnDeleteAccountSceneLibrariesSubscription = {
  onDeleteAccountSceneLibraries?: {
    __typename: "AccountSceneLibraries";
    id: string;
    accountID: string;
    sceneLibraryID: string;
    account: {
      __typename: "Account";
      id: string;
      gid: string;
      name: string;
      aliasId: string;
      minisiteDomain?: string | null;
      mfaEnabled?: boolean | null;
      ownerId?: string | null;
      accountUsageType?: string | null;
      companySize?: string | null;
      tierId: string;
      stripeCustomerId?: string | null;
      createNewVideosWithBlingLogo?: boolean | null;
      createdAt: string;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateProjectSceneLibrariesSubscriptionVariables = {
  filter?: ModelSubscriptionProjectSceneLibrariesFilterInput | null;
};

export type OnCreateProjectSceneLibrariesSubscription = {
  onCreateProjectSceneLibraries?: {
    __typename: "ProjectSceneLibraries";
    id: string;
    projectID: string;
    sceneLibraryID: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateProjectSceneLibrariesSubscriptionVariables = {
  filter?: ModelSubscriptionProjectSceneLibrariesFilterInput | null;
};

export type OnUpdateProjectSceneLibrariesSubscription = {
  onUpdateProjectSceneLibraries?: {
    __typename: "ProjectSceneLibraries";
    id: string;
    projectID: string;
    sceneLibraryID: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteProjectSceneLibrariesSubscriptionVariables = {
  filter?: ModelSubscriptionProjectSceneLibrariesFilterInput | null;
};

export type OnDeleteProjectSceneLibrariesSubscription = {
  onDeleteProjectSceneLibraries?: {
    __typename: "ProjectSceneLibraries";
    id: string;
    projectID: string;
    sceneLibraryID: string;
    project: {
      __typename: "Project";
      id: string;
      projectAccountId: string;
      title: string;
      allowCreateDataPoint?: boolean | null;
      allowDataConnect?: boolean | null;
      allowCrmConnect?: boolean | null;
      allowSdkConnect?: boolean | null;
      allowSendFormData?: boolean | null;
      analyticsReportUrl?: string | null;
      createdAt?: string | null;
      description?: string | null;
      fileName?: string | null;
      jsonChanges?: string | null;
      jsonVidUrl?: string | null;
      settings?: string | null;
      stateJsonSchemaStr?: string | null;
      settingsJsonSchemaStr?: string | null;
      thumbS3Url?: string | null;
      experimentOptimizationTechnique?: ExperimentOptimizationTechnique | null;
      analyticsEnabled?: boolean | null;
      owner?: string | null;
      aliasId: string;
      playerVersionToUse?: string | null;
      customHtml?: string | null;
      publishedAt?: string | null;
      allowedOrigins?: Array<string | null> | null;
      textToVideoScript?: string | null;
      instantiatedFromUseCase?: string | null;
      isDeleted?: boolean | null;
      updatedAt: string;
    };
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateUseCaseSceneLibrariesSubscriptionVariables = {
  filter?: ModelSubscriptionUseCaseSceneLibrariesFilterInput | null;
};

export type OnCreateUseCaseSceneLibrariesSubscription = {
  onCreateUseCaseSceneLibraries?: {
    __typename: "UseCaseSceneLibraries";
    id: string;
    sceneLibraryID: string;
    useCaseID: string;
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    useCase: {
      __typename: "UseCase";
      id: string;
      name: string;
      projectId: string;
      images?: Array<string> | null;
      shortDescription?: string | null;
      longDescription?: string | null;
      thumbnail?: string | null;
      demoLink?: string | null;
      videoPreview?: string | null;
      lineupId?: string | null;
      lineupsIds?: Array<string> | null;
      scenes?: Array<string> | null;
      liveControl?: string | null;
      liveControlSchema?: string | null;
      dynamicDataSchema?: string | null;
      categoryId?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateUseCaseSceneLibrariesSubscriptionVariables = {
  filter?: ModelSubscriptionUseCaseSceneLibrariesFilterInput | null;
};

export type OnUpdateUseCaseSceneLibrariesSubscription = {
  onUpdateUseCaseSceneLibraries?: {
    __typename: "UseCaseSceneLibraries";
    id: string;
    sceneLibraryID: string;
    useCaseID: string;
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    useCase: {
      __typename: "UseCase";
      id: string;
      name: string;
      projectId: string;
      images?: Array<string> | null;
      shortDescription?: string | null;
      longDescription?: string | null;
      thumbnail?: string | null;
      demoLink?: string | null;
      videoPreview?: string | null;
      lineupId?: string | null;
      lineupsIds?: Array<string> | null;
      scenes?: Array<string> | null;
      liveControl?: string | null;
      liveControlSchema?: string | null;
      dynamicDataSchema?: string | null;
      categoryId?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteUseCaseSceneLibrariesSubscriptionVariables = {
  filter?: ModelSubscriptionUseCaseSceneLibrariesFilterInput | null;
};

export type OnDeleteUseCaseSceneLibrariesSubscription = {
  onDeleteUseCaseSceneLibraries?: {
    __typename: "UseCaseSceneLibraries";
    id: string;
    sceneLibraryID: string;
    useCaseID: string;
    sceneLibrary: {
      __typename: "SceneLibrary";
      id: string;
      title: string;
      vibe?: string | null;
      projectId: string;
      description?: string | null;
      thumbnail?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    useCase: {
      __typename: "UseCase";
      id: string;
      name: string;
      projectId: string;
      images?: Array<string> | null;
      shortDescription?: string | null;
      longDescription?: string | null;
      thumbnail?: string | null;
      demoLink?: string | null;
      videoPreview?: string | null;
      lineupId?: string | null;
      lineupsIds?: Array<string> | null;
      scenes?: Array<string> | null;
      liveControl?: string | null;
      liveControlSchema?: string | null;
      dynamicDataSchema?: string | null;
      categoryId?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};
